import AppConstants from '../../config/app.constants';

class MasterCashScheduleController {
  /*@ngInject*/
  constructor(
    $state,
    $q,
    $window,
    $scope,
    Modal,
    User,
    SetupService,
    DateUtil,
    Sound,
    $translate,
    DenominationService,
    UserBranchService,
    $rootScope,
    BranchFundingSourceService,
    CustomerService,
    LocationService,
    CommonLayoutService,
    RouteService,
    OrderViewService,
    Navigation,
    DataCounter,
    ShiptypeService,
    ShipmentService,
    OrderPackingService,
    ServiceOrderService,
    UserBranchFundingSourceService,
    $location
  ) {
    this.$rootScope = $rootScope;
    this.$q = $q;
    this.$state = $state;
    this.$window = $window;
    this.User = User;
    this.SetupService = SetupService;
    this.DenominationService = DenominationService;
    this.CustomerService = CustomerService;
    this.LocationService = LocationService;
    this.DateUtil = DateUtil;
    this.UserBranchService = UserBranchService;
    this.BranchFundingSourceService = BranchFundingSourceService;
    this.RouteService = RouteService;
    this.CommonLayoutService = CommonLayoutService;
    this.OrderViewService = OrderViewService;
    this.Navigation = Navigation;
    this.DataCounter = DataCounter;
    this.Modal = Modal;
    this.$scope = $scope;
    this.MAXLIMIT = 1000;
    this.ShiptypeService = ShiptypeService;
    this.ShipmentService = ShipmentService;
    this.ServiceOrderService = ServiceOrderService;
    this.OrderPackingService = OrderPackingService;
    this.$translate = $translate;
    this.$location = $location;
    this.UserBranchFundingSourceService = UserBranchFundingSourceService;
    this.$currentTab = "";
    this.$currentViewTab = "table";
    this.icon = {
      'REGULAR': 'regular.png',
      'ATM': 'atm.png',
      'BANK': 'bank.png',
      'NO_SHIP_NO_GO': 'nsng.png',
      'INTERNAL': 'internal.png',
      'TRUCK': 'truck.png',
      'TANKER': 'tanker.png',
      'WINDOW': 'window.png',
      'ON_CALL': 'oncall.png',
      'CARRIER': 'carrier.png',
      'LOCKER': 'locker.png',
      'VAULT': 'vault.png',
      'DELIVERY': 'delivery.png'
    }
    this.filterDataSet = {
      userBranches: [],
      branchFundingSource: [],
      totalBranchFundingSource: 0,
      status: [],
      totalCustomer: 0,
      customerList: [],
      totalLocation: 0,
      locationList: [],
      orderTypes: this.CommonLayoutService.orderTypes(),
      denomsList: [],
      multiPackabledenomsList: [],
      singlePackabledenomsList: [],
      routeList: [],
      totalRoutes: 0, 
      currentVaultDate: null,
    };
    
    this.mainPageFilters = {
      totalLocation: 0,
      locationList: [],
      offset: 0,
    };
    // this.audio = this.Sound.errorBeep();
    // this.successAudio = this.Sound.successBeep();

    this.allStatus = [
      { Value: 'pendingPack',   Key: 'Pending Pack'  },
      { Value: 'CRVed',         Key: 'CRVed'         },
      { Value: 'packed',        Key: 'Packed'        },
      { Value: 'completed',     Key: 'Completed'     },
      { Value: 'hold',          Key: 'Hold'          },
      { Value: 'scheduled',     Key: 'Scheduled'     }
    ];
    this.filterDataSet.status = this.allStatus;
    this.filterDataSet.totalStatus = this.filterDataSet.status.length;

    this.monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

    this.weekDaysName = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];

    this.denominationAllType = [];
    this.allDenoms = [];
    this.denomModelType = ['single', 'multi', 'atm'];
    this.sortColumn = ''; 
    this.reverseSort = false;
    this.allOrderTypes = [];
    
    this.handleOrderTypeChange = (value) => {
      if (this.newCash.status === 'scheduled') {
        this.newCash.shiptypeId = value;
      } else {
        this.newCash.orderType = value;
      }
    };
    
    this.updateOrderTypeOrShiptypeId = () => {
      this.newCash.orderTypeOrShiptypeId = this.newCash.orderType || this.newCash.shiptypeId;
    };
    
    this.newCash = {
      orderNo: null,
      locationId: null,
      orderType: null,
      vaultDate: null,
      routeId: null,
      denominations: [],
      trackingIdDelivery: null,
      batchId: null,
      multiDenomPackableDenoms: [],
      singleDenomPackableDenoms: [],
      remainingDenominations: [],
      multiDenominations: [],
      remainingMultiDenominations:[],
      remainingAtmDenominations: [],
      atmDenominations:[],
      isInteracted: false
    };

    this.newCash.orderTypeOrShiptypeId = null;

        this.updatedCash = {
            orderNo: null,
            locationId: null,
            orderType: null,
            vaultDate: null,
            routeId: null,
            denominations: [],
            trackingIdDelivery: null,
            batchId: null,
            multiDenominations: []
        }

    this.filter = {};
    this.branchId = this.User.getUser().branchId;
    this.userDetails = this.User.getUser();
    this._calendar = {
      displayMonth: "",
      displayYear: "",
      monthIndex: 0,
      selectedDateData: null,
    };
    this.calendarDays = [];
    this.dateRangPickerOptions = {
      autoApply: true,
      eventHandlers: {
        "apply.daterangepicker": () => {
          // console.log(this.dateRangeOptions.startDate)
          this.generateCalendarDays(this._calendar.monthIndex, this.dateRangeOptions.startDate.format("MMM DD YYYY"));
        },
      },
    };
    this.$rootScope.$broadcast("routeChange", "/app/master-cash-schedule");
    this.currentOrderStat = null;
    this.orderStatObj = {
      atRisk: "atRisk",
      ATM: "ATM",
      Cash: "Cash",
      Scheduled: "Scheduled",
      All: "All"
    };

    this.shipmentsCreateStats = {
      prePacked: { all: "prePacked" },
      cashDeliveries: { single: "single", recurring: "recurring", all: "cashDeliveries" },
      ATMOrders: { single: "single", recurring: "recurring", all: "ATMOrdersView" },
      stops: { multiple: "multiple" },
    };

    this.model = {
      // currentScheduledStats: 'ATM',
      currentStats: this.shipmentsCreateStats.prePacked.all,
      currentChildStat: null,
      ATMLoadAccountStats: {
        regular: "Regular",
        emergency: "Emergency",
      },
    };

    this.istevenMultiSelectLocalLang = {
      selectAll: "Select all",
      selectNone: "Select None",
      reset: "Reset",
      search: "Search.",
      nothingSelected: "Select Denomination",
    };

    this.denominationTypeMapping = {
      PENNY: {
        category: "01",
        categoryName: "coin1",
        template: null,
        coinFlag: true,
      },
      NICKEL: {
        category: "05",
        categoryName: "coin5",
        template: null,
        coinFlag: true,
      },
      DIMES: {
        category: "10",
        categoryName: "coin10",
        template: null,
        coinFlag: true,
      },
      QUARTER: {
        category: "25",
        categoryName: "coin25",
        template: null,
        coinFlag: true,
      },
      HALF_US_DOLLAR: {
        category: "50",
        categoryName: "coin50",
        template: null,
        coinFlag: true,
      },
      ONE_US_DOLLAR: {
        category: "1$",
        categoryName: "coin1$",
        template: null,
        coinFlag: true,
      },
      COIN_MISC: {},
    };
    this.coinTypes = {};

    this.fromLocationObj = {
      results: [],
      totalRecords: 0,
      pagination: {
        page: 1,
        total: 0,
        pageLimit: 10,
        maxPages: 10,
      },
      loading: false,
    };

    this.deliveryLocationObj = {
      results: [],
      totalRecords: 0,
      pagination: {
        page: 1,
        total: 0,
        pageLimit: 10,
        maxPages: 10,
      },
      loading: false,
    };

    // this.scheduledATMShipmentObj = {
    //     results: [],
    //     totalRecords: 0,
    //     pagination: {
    //         page: 1,
    //         total: 0,
    //         pageLimit: 10,
    //         maxPages: 10
    //     },
    //     loading: false,
    // }

    // this.scheduledCashShipmentObj = {
    //     results: [],
    //     totalRecords: 0,
    //     pagination: {
    //         page: 1,
    //         total: 0,
    //         pageLimit: 10,
    //         maxPages: 10
    //     },
    //     loading: false,
    // }


    this.getHeaderTotal = () => {

      if (!this.newCash) return 0;

      // When editing a packable (Change) order, use shipment-level cash/coin
      if (this.newCash.isPackableOrder) {
        const cashFromShipments = this.newCash.cashShipmentAmount || 0;
        const coinFromShipments = this.newCash.coinShipmentAmount || 0;
        const packableTotal = cashFromShipments + coinFromShipments;
        if (packableTotal > 0) {
          return packableTotal;
        }
      } else {
        // For non-packable (ATM / COD) orders, use cashAmount + coinAmount
        const cashFromFields = this.newCash.cashAmount || 0;
        const coinFromFields = this.newCash.coinAmount || 0;
        const liveTotal = cashFromFields + coinFromFields;
        if (liveTotal > 0) {
          return liveTotal;
        }
      }

      return 0;
    };

    // this.scheduledStats = {
    //     ATM: 'ATM',
    //     Cash: 'Cash',
    // }

    this.toggleSwitchUI = {
      size: "mini",
      label: {
        on: this.$translate.instant("common.on"),
        off: this.$translate.instant("common.off"),
      },
      onColor: "success",
      offColor: "danger",
    };

    this.recurringPatternList = [
      {
        label: "Daily",
        value: "daily",
      },
      {
        label: "Weekly",
        value: "weekly",
      },
      {
        label: "Monthly",
        value: "monthly",
      },
    ];

    this.serviceSchedule = [
      {
        label: "Monday",
        value: "monday",
      },
      {
        label: "Tuesday",
        value: "tuesday",
      },
      {
        label: "Wednesday",
        value: "wednesday",
      },
      {
        label: "Thursday",
        value: "thursday",
      },
      {
        label: "Friday",
        value: "friday",
      },
      {
        label: "Saturday",
        value: "saturday",
      },
      {
        label: "Sunday",
        value: "sunday",
      },
    ];

    this.monthList = [
      {
        label: "Jan",
        value: "january",
      },
      {
        label: "Feb",
        value: "february",
      },
      {
        label: "March",
        value: "march",
      },
      {
        label: "April",
        value: "april",
      },
      {
        label: "May",
        value: "may",
      },
      {
        label: "June",
        value: "june",
      },
      {
        label: "July",
        value: "july",
      },
      {
        label: "Aug",
        value: "august",
      },
      {
        label: "Sep",
        value: "september",
      },
      {
        label: "Oct",
        value: "october",
      },
      {
        label: "Nov",
        value: "november",
      },
      {
        label: "Dec",
        value: "december",
      },
    ];

    this.customerUser = this.User.getUser().customerUser ? this.User.getUser().customerId : null;
    this.isValidBillCount = true;
    this.isValidStrapBillCount = true;
    this.invalidSingleDenomCoin = false;
    this.invalidSingleDenomCoinList = [];
    this.selectedMonthlyPattern = "day";
    this.allOrders=[]
    this.multiDenomIndex = 0;
    this.singleDenomIndex = 0;
    this.atmDenomIndex = 0;
  }

  $onInit() {
    this.filterDataSet.orderTypes.push({ key: 'Change Order Delivery', value: 'COD' });
    this.denomSearchObj = {};
    this.model.gettingServiceOrder =true;
    this.$q
      .all([
        this.SetupService.get(this.branchId),
        this.DenominationService.all(null, 0, this.MAXLIMIT),
        this.ShiptypeService.all(null, 0, this.MAXLIMIT),
        this.loadUserBranches("", 0),
        this.getAllFundingSource("", 0),
        this.getCustomer("", 0),
        this.loadLocation("", 0, true),
        this.loadFromLocation("", 0),
        this.resetDateRange(),
        this.getActiveRoutes(0, ""),
      ])
      .then(data => {
        let allDenoms = _.orderBy(data[1].results, ["sortOrder"], ["asc"]);
        this.allDenoms = allDenoms;
        this.newCash.multiDenomPackableDenoms = allDenoms.length ? allDenoms.filter(d => d.multiDenomPackable == true) : [];
        this.newCash.singleDenomPackableDenoms = allDenoms.length ? allDenoms.filter(d => d.multiDenomPackable == false) : [];

        this.newCash.remainingMultiDenominations = allDenoms.filter(d => d.multiDenomPackable);
        this.newCash.remainingSingleDenominations = allDenoms.filter(d => !d.multiDenomPackable);
        this.denominationAllType = allDenoms.length ?allDenoms : [];
        this.setupDetails = data[0];
        this.shiptypeList = _.orderBy(data[2].results, ["sortOrder"], ["ASC"]);

        this.branchHoldRoute = this.setupDetails.holdRouteId;
        this.branchUnassignedRoute = this.setupDetails.unassignedRouteId;
        this.branchCurrentVaultDate = this.setupDetails.currentVaultDate;

        this.filterDataSet.denomsList = this.mappingData(this.denominationAllType, "name", "id");
        this.filterDataSet.multiPackabledenomsList = this.mappingData(this.newCash.multiDenomPackableDenoms, "name", "id");
        this.filterDataSet.singlePackabledenomsList = this.mappingData(this.newCash.singleDenomPackableDenoms, "name", "id");
        this.resetDateRange();

        this.loadPermission();
        this.generateCalendarDays(this._calendar.monthIndex);
        this.removeUsedDenoms();

        const customerDetails = _.find(this.filterDataSet.customerList, { Value: this.userDetails.customerId });
        const customer = this.userDetails.customerUser ? customerDetails : null;
        this.filter.customerId = customer;

        this.shiptypeList.forEach(s => {
          if (this.denominationTypeMapping[s.denominationType] && !this.coinTypes[s.denominationType]) {
            this.coinTypes[s.denominationType] = {
              denomList: [],
              isOpen: false,
              template: `order-view-coin-selection.html`,
              selected: null,
              category: null,
              categoryName: null,
            };
          }
        });

        this.shiptypeList.forEach(s => {
          if (this.denominationTypeMapping[s.denominationType]) {
            this.coinTypes[s.denominationType].denomList.push({
              icon: s.id,
            });
            this.coinTypes[s.denominationType].coinFlag = true;
            this.coinTypes[s.denominationType].category = this.denominationTypeMapping[s.denominationType].category;
            this.coinTypes[s.denominationType].categoryName = this.denominationTypeMapping[s.denominationType].categoryName;
            this.coinTypes[s.denominationType].selected = this.coinTypes[s.denominationType].denomList[0].icon;
          }
        });

        this.coinValues = {};

        if (this.shiptypeList) {
          this.shiptypeList.map(shiptype => {
            this.coinValues[shiptype.id] = {
              amountFlag: shiptype.amountFlag,
              unitValue: shiptype.unitValue,
              amount: shiptype.amount,
            };
          });
        }

        this.denominationTypeKeys = Object.keys(this.coinTypes).sort((a, b) => {
          const aMinSortOrder = _.min(this.shiptypeList.filter(s => s.denominationType === a).map(s => s.sortOrder)) || 999;
          const bMinSortOrder = _.min(this.shiptypeList.filter(s => s.denominationType === b).map(s => s.sortOrder)) || 999;
          return aMinSortOrder - bMinSortOrder;
        });
        this.allOrderTypes = [...this.filterDataSet.orderTypes].filter(o => o.key !== "Change Order Delivery");
      })
      .catch(err => {
        console.log(err);
      });
  }

  loadPermission() {
    this.acl = {};
    this.hasACL = {};

    ["master_cash_schedule"].forEach(permissionKey => {
      this.acl[permissionKey] = this.User.getACL(permissionKey);

      this.hasACL[permissionKey] = {};

      this.acl[permissionKey].forEach(permission => {
        this.hasACL[permissionKey][permission] = true;
      });
    });
  }

  // Get current time
  getTime(time) {
    if (!time) {
      return time;
    }

    time = time.split(":");

    let d = new Date();

    d.setHours(+time[0]);
    d.setMinutes(time[1]);
    d.setSeconds(0);
    d.setMilliseconds(0);

    return d;
  }

  getStartDateForCalendar = function (selectedDate) {
    let lastDayOfPreviousMonth = new Date(selectedDate.setDate(0));

    // start by setting the starting date of the calendar same as the last day of previous month
    let startingDateOfCalendar = lastDayOfPreviousMonth;

    // but since we actually want to find the last Monday of previous month
    // we will start going back in days intil we encounter our last Monday of previous month
    if (startingDateOfCalendar.getDay() != 0) {
      do {
        startingDateOfCalendar = new Date(startingDateOfCalendar.setDate(startingDateOfCalendar.getDate() - 1));
      } while (startingDateOfCalendar.getDay() != 0);
    }

    return startingDateOfCalendar;
  };

  CalendarDay(d) {
    const vaultDate = this.DateUtil.convertToDate(this.branchCurrentVaultDate);
    return {
      date: d,
      isPastDate: d.setHours(0, 0, 0, 0) < new Date().setHours(0, 0, 0, 0),
      isToday: d.setHours(0, 0, 0, 0) == new Date(vaultDate).setHours(0, 0, 0, 0),
      isMonthDate: d.getMonth() == this.monthNames.indexOf(this._calendar.displayMonth),
      formatedDate: moment(d).format("YYYY-MM-DD"),
    };
  }


  getAllStatus(searchKey) {
    if (!searchKey) {
        this.filterDataSet.status = this.allStatus;
    } else {
        this.filterDataSet.status = this.allStatus.filter(status =>
            status.Key.toLowerCase().includes(searchKey.toLowerCase())
        );
    }
}

  generateCalendarDays(monthIndex, date = null) {
    // we reset our calendar
    this.calendar = [];

    // we set the date
    // let day = new Date(
    //     new Date().setMonth(new Date().getMonth() + monthIndex)
    // );
    // console.log(date, monthIndex);
    let now = date ? new Date(date) : new Date();
    let current = new Date(now.getFullYear(), now.getMonth() + monthIndex);

    let currentMonth = `${new Date().getMonth()}${new Date().getFullYear()}`;
    let selectedMonth = `${current.getMonth()}${current.getFullYear()}`;
    this.formattedSelectedMonth = `${current.getMonth() + 1}-${current.getFullYear()}`;
    this.hidePreviousMonth = parseInt(currentMonth) > parseInt(selectedMonth);
    // set the dispaly month for UI
    this._calendar.displayMonth = this.monthNames[current.getMonth()];
    this._calendar.displayYear = current.getFullYear();

    let startingDateOfCalendar = this.getStartDateForCalendar(current);

    let dateToAdd = startingDateOfCalendar;

    for (var i = 0; i < 42; i++) {
      this.calendar.push(this.CalendarDay(new Date(dateToAdd)));
      dateToAdd = new Date(dateToAdd.setDate(dateToAdd.getDate() + 1));
    }

    this.setCalendarWeeks();
    this.onDateSelect(null);
    this.getAtmOrders();
  }

  nextMonth() {
    this._calendar.monthIndex++;
    this._calendar.isSidePanelOpen = false;
    this._calendar.isNew = false;
    this._calendar.isEdit = false;
    // this.resetDateRange();
    this.generateCalendarDays(this._calendar.monthIndex);
    this.setStartDate(this.formattedSelectedMonth);
    this.setEndDate(this.formattedSelectedMonth);
  }

  previousMonth() {
    this._calendar.monthIndex--;
    this._calendar.isSidePanelOpen = false;
    this._calendar.isNew = false;
    this._calendar.isEdit = false;
    // this.resetDateRange();
    this.generateCalendarDays(this._calendar.monthIndex);
    this.setStartDate(this.formattedSelectedMonth);
    this.setEndDate(this.formattedSelectedMonth);
  }

  onDateSelect(dayData, index) {
    this._calendar.selectedDateData = dayData;
    this._calendar.isSidePanelOpen = !!dayData;
  }

  setCalendarWeeks() {
    this.calendarDays = [];
    let weekDays = [];
    let chunkSize = 7;
    this.calendar.map((day, index) => {
      weekDays.push(day);
      if (++index % chunkSize === 0) {
        let isCurrentMonth = weekDays.filter(item => item.isMonthDate);
        if (isCurrentMonth && isCurrentMonth.length) {
          this.calendarDays.push(weekDays);
        }
        weekDays = [];
      }
    });
  }

  loadImage = function (image) {
    let imgURL = this.icon[image]
    return require('../../assets/images/' + imgURL);
  }

  createNewCashSchedule(day, fromTabSelecation = false) {
    day = day || moment();

    this._calendar.isEdit = false;
    this._calendar.isNew = true;
    this.newCash = {
      batchId: "B1-" + moment().toDate().getTime(),
      fromLocation: null,
      toLocation: null,
      vaultDate: moment(day.formatedDate),
      routeId: null,
      cashAmount: 0,
      coinAmount: 0,
      totalAmount: 0,
      isInteracted: false,
      trackingId: null,
      coinShipmentObj: {},
      branchId: this.model.branch,
      recurringStartDate: moment(day.formatedDate),
      recurringEndDate: null,
      recurringDays: {
        monday: false,
        tuesday: false,
        wednesday: false,
        thursday: false,
        friday: false,
        saturday: false,
        sunday: false,
      },
      recurringMonths: {
        january: false,
        february: false,
        march: false,
        april: false,
        may: false,
        june: false,
        july: false,
        august: false,
        september: false,
        october: false,
        november: false,
        december: false,
      },
      selectedPattern: "daily",
      recurWeeks: 0,
      recurringMonthObj: {
        day: {
          dayInterval: null,
          monthInterval: null,
        },
        month: {
          weekInterval: null,
          selectedWeekDay: null,
          monthInterval: null,
          weekIntervalList: [
            {
              lable: "First",
              value: 1,
            },
            {
              lable: "Second",
              value: 2,
            },
            {
              lable: "Third",
              value: 3,
            },
            {
              lable: "Forth",
              value: 4,
            },
            {
              lable: "Fifth",
              value: 5,
            },
          ],
          weekDayList: [
            {
              lable: "Sunday",
              value: 0,
            },
            {
              lable: "Monday",
              value: 1,
            },
            {
              lable: "Tuesday",
              value: 2,
            },
            {
              lable: "Wednesday",
              value: 3,
            },
            {
              lable: "Thursday",
              value: 4,
            },
            {
              lable: "Friday",
              value: 5,
            },
            {
              lable: "Saturday",
              value: 6,
            },
          ],
        },
      },
      endRecurringAfter: null,
      account: this.model.ATMLoadAccountStats.regular,
    };
    this.isValidBillCount = true;
    this.isValidStrapBillCount = true;
    this.onDateSelect(day);
    this.getActiveRoutes(0, "");
    this.scrollToTop();
    this.addNewDenominations();
    this.model.currentStats = null;
     if(this.customerUser){
       if (!fromTabSelecation) {
         this.$currentTab = 'cashDeliveries';
       }
      this.filterOrderTypes();
      this.model.currentStats = this.shipmentsCreateStats.cashDeliveries.all;
      this.model.currentChildStat = this.shipmentsCreateStats.cashDeliveries.single;
      this.newCash.orderType = 'COD';
      if(!fromTabSelecation){
        this.generateOrderNumber();
      }
    } else {
    this.model.currentStats = this.shipmentsCreateStats.prePacked.all;
    }
    this.validateRecurringStartDate();
    this.updateOrderTypeOrShiptypeId();
    this.setMaxDate(moment(this.filterDataSet.currentVaultDate));
  }

  editCashSchedule(data) {
    this._calendar.isSidePanelOpen = true;
    this.onDateSelect(data);
    this.scrollToTop();
    let denominations=[];
    let multiDenominations=[];
    let atmDenominations=[];
    let date = this.normalizeDate(data.serviceDate);
      if (data.isPackableOrder) {

          denominations      = angular.copy(data.denominations.filter(o => !o.multiDenomPackable));
          multiDenominations = angular.copy(data.denominations.filter(o =>  o.multiDenomPackable));
        } else {
          atmDenominations   = angular.copy(data.denominations);
        }
    let obj = {
      id: new Date().getTime(),
      vaultDate: this.DateUtil.convertToDate(date),
      amount: data.amount,
      orderNo: data.orderNo,
      locationId: { Key: data.toLocationId + " | " + data.toLocationName, Value: data.toLocationId } || null,
      orderType: data.orderType || null,
      routeId: data.routeId || null,
      denominationId: data.denominationId,
      multiDenominations: multiDenominations || [],
      denominations: denominations || [],
      fetchedDenominations: data.fetchedDenominations || [],
      atmDenominations: atmDenominations || [],
      trackingIdDelivery: data.trackingIdDelivery,
      packedFlag: data.packedFlag,
      batchId: data.batchId,
      coinShipments: data.coinShipments ? data.coinShipments.map(coinShipment => ({
        ...coinShipment,
        shiptypeId: coinShipment.denominationId || coinShipment.shiptypeId
      })) : [],
      shiptypeId: data.shiptypeId,
      coinShipmentAmount: data.coinShipmentAmount,
      cashShipmentAmount: data.cashShipmentAmount,
      fundingSourceId: data.fundingSourceId,
      fundingSourceName: data.fundingSourceName,
      fundingSource: this.filterDataSet.branchFundingSource.find(bfs => String(bfs.Value) === String(data.fundingSourceId)) || data.fundingSource,
      trackingIds: data.trackingIds,
      status: data.status,
      loadedAmount: data.loadedAmount,
      deliveredFlag: data.deliveredFlag,
      cashOrderId: data.cashOrderId,
      shipmentId: data.shipmentId,
      jobKey: data.jobKey || null,
      jobId: data.jobId || null,
      scheduleWeekDays: data.scheduleWeekDays || null,
      recurringFrequency: data.recurringFrequency || null,
      recurringDayInterval: data.recurringDayInterval || null,
      frequencyWeek: data.frequencyWeek || null,
      locationScheduleRecurringId: data.locationScheduleRecurringId || null,
      isEC: data.isEC,
      editAmount: data.editAmount,
      isPackableOrder: data.isPackableOrder,
      type: data.type
    };

    this.newCash = Object.assign(this.newCash, obj);
    this.updateOrderTypeOrShiptypeId();
    this.cloneShipmentObj = angular.copy(this.newCash);
    this.editRouteLookupDate = this.getFormattedVaultDate(this.newCash.vaultDate);

    if (data.denominations && data.denominations.length) {
      this.removeUsedDenoms();
    }

    if (this.newCash.isPackableOrder) {
      if (this.newCash.remainingDenominations && Array.isArray(this.newCash.remainingDenominations)) {
        this.newCash.remainingDenominations.forEach(atmDenom => {
          if (!atmDenom.multiDenomPackable) { // Check if multiDenomPackable is false
            this.newCash.denominations.push({
              ...atmDenom, 
              isEnabled: false, 
              amount: null,
              template: "order-view-denomination-selection.html",
            });
          }
        });
      }
      if (this.newCash.remainingMultiDenominations && Array.isArray(this.newCash.remainingMultiDenominations)) {
        this.newCash.remainingMultiDenominations.forEach(atmDenom => {
          if (atmDenom.multiDenomPackable) { // Check if multiDenomPackable is false
            this.newCash.multiDenominations.push({
              ...atmDenom, 
              isEnabled: false, 
              amount: null,
              template: "order-view-multi-denomination-selection.html",
            });
          }
        });
      }
    } else {
      if (this.newCash.remainingAtmDenominations && Array.isArray(this.newCash.remainingAtmDenominations)) {
        this.newCash.remainingAtmDenominations.forEach(atmDenom => {
          this.newCash.atmDenominations.push({
            ...atmDenom, 
            isEnabled: false, 
            amount: null,
            icon: atmDenom.id,
            template: "order-view-atm-denomination-selection.html",
          });
        });
      }
    }
    
    if (this.userDetails.customerUser) {
      const customerLeadMinDate = this.getCustomerLeadMinDate();
      this.setMaxDate(customerLeadMinDate || this.filterDataSet.currentVaultDate);
    } else {
      this.setMaxDate(this.filterDataSet.currentVaultDate);
    }
    this._calendar.isEdit = true;
    this.calculateDenominationAmount();
    this.validateBillCount();
    this.checkForStrapCount();
    if (this.newCash.batchId && this.newCash.coinShipments && this.newCash.coinShipments.length > 0) {
      const calculatedCoinAmount = this.newCash.coinShipments.reduce((sum, coinShipment) => {
        return sum + (coinShipment.amount || 0);
      }, 0);
      this.newCash.coinShipmentAmount = calculatedCoinAmount;
    }
    
    this.updatedCash = angular.copy(this.newCash);
    this._calendar.isNew = false;
  }

  addNewDenominations() {
    const length = this.model.currentStats === this.shipmentsCreateStats.cashDeliveries.all ? 5 : 4;
    this.newCash.denominations = [];
    this.newCash.multiDenominations = [];
    this.newCash.atmDenominations = [];

    this.denomModelType.forEach((d) => {
      let type, remainingDenomModelKey;
      switch (d) {
        case "single":
          type = 'denominations';
          remainingDenomModelKey = 'remainingDenominations';
          break;
        case "multi":
          type = 'multiDenominations';
          remainingDenomModelKey = 'remainingMultiDenominations';
          break;
        case "atm":
          type = 'atmDenominations';
          remainingDenomModelKey = 'remainingAtmDenominations';
          break;
        default:
          'denominations';
      }

      for (var i = 0; this.newCash[type] &&this.newCash[type].length < length; i++) {
        this.newCash[type].push({
          id: i == 0 ? 'USD20' :  this.newCash[remainingDenomModelKey][0] && this.newCash[remainingDenomModelKey][0].id,
          isEnabled: i == 0 ? true : false,
          icon: i == 0 ? "USD20" : this.newCash[remainingDenomModelKey].length > 0 ? this.newCash[remainingDenomModelKey][0].id : null,
          faceValue: i == 0 ? 20 : this.newCash[remainingDenomModelKey].length > 0 ? this.newCash[remainingDenomModelKey][0].faceValue : 0,
          amount: null,
          template: d == "single" ? "order-view-denomination-selection.html" :d=='multi'? "order-view-multi-denomination-selection.html":"order-view-atm-denomination-selection.html",
          dollorFlag: true,
          duplicate: false,
          multiDenomPackable: i == 0 ? true : this.newCash[remainingDenomModelKey][0] && this.newCash[remainingDenomModelKey][0].multiDenomPackable,
          strapCount: i == 0 ? 100 : this.newCash[remainingDenomModelKey][0] && this.newCash[remainingDenomModelKey][0].strapCount || 0,
        });
        this.removeAlreadyUsedDenom(type, remainingDenomModelKey);
      }
    })
  }

  changeDenomType(event, index, denomination, type) {
    this.newCash[type][index].icon = denomination.id;
    this.newCash[type][index].faceValue = denomination.faceValue;
    this.newCash[type][index].isOpen = false;
    this.newCash[type][index].isValid = false;
    this.newCash[type][index].multiDenomPackable = denomination.multiDenomPackable;
    this.newCash[type][index].coinFlag = denomination.coinFlag;
    this.newCash[type][index].sortOrder = denomination.sortOrder;
    this.newCash[type][index].strapCount = denomination.strapCount;
    this.newCash[type][index].shiptypeId = denomination.shiptypeId;

    if (this.shouldUseAmountInput(this.newCash[type][index])) {
      this.newCash[type][index].amount = null;
      this.newCash[type][index].billCount = null;
    } else {
      this.checkAmount(index, this.newCash[type][index].billCount, denomination.faceValue, type);
    }

    this.calculateDenominationAmount(type);
    this.removeUsedDenoms();

    if (type === 'denominations') {
      this.checkSingleDenomCoinShiptype();
    }

    // this.removeAlreadyUsedDenom(type, type == 'denominations' ? 'remainingDenominations' ? 'atmDenominations' : 'remainingAtmDenominations': 'remainingMultiDenominations');
  }

  checkSingleDenomCoinShiptype() {
    const invalidDenoms = (this.newCash.denominations || []).filter(denomination =>
      denomination && denomination.isEnabled && denomination.coinFlag &&
      (!denomination.shiptypeId || denomination.icon !== denomination.shiptypeId)
    );
    this.invalidSingleDenomCoinList = invalidDenoms.map(d => d.icon);
    this.invalidSingleDenomCoin = invalidDenoms.length > 0;
    return this.invalidSingleDenomCoin;
  }

  getInvalidSingleDenomCoinMessage() {
    const list = this.invalidSingleDenomCoinList || [];
    if (!list.length) return '';
    return list.length > 1
      ? `Selected (${list.join(', ')}) denominations do not have a valid shiptype configured.`
      : `Selected (${list.join(', ')}) denomination does not have a valid shiptype configured.`;
  }

  closePanel() {
    this._calendar.isEdit = false;
    this.onDateSelect(null);
    this.isValidBillCount = true;
    this.isValidStrapBillCount = true;
    this.invalidSingleDenomCoin = false;
    this.invalidSingleDenomCoinList = [];
    this.newCash.atmDenominations = [];
    this.newCash.denominations = [];
    this.newCash.multiDenominations = [];
    this.updatedCash = {
      orderNo: null,
      locationId: null,
      orderType: null,
      vaultDate: null,
      routeId: null,
      denominations: [],
      trackingIdDelivery: null,
      batchId: null,
      multiDenominations: []
    }
  }

  handleDenomination(denomination, type) {
    if (type==='remainingDenominations') {
      denomination=this.newCash.denominations.find(d => d.isEnabled === false);
    } else if (type==='remainingMultiDenominations') {
      denomination=this.newCash.multiDenominations.find(d => d.isEnabled === false);
    } else if (type==='remainingAtmDenominations') {
      denomination=this.newCash.atmDenominations.find(d => d.isEnabled === false);
    }
    denomination.isEnabled = !denomination.isEnabled;

    if ('isDeleted' in denomination) {
      denomination.isDeleted = false;
  }
    if (!denomination.isEnabled) {
        denomination.icon = "";
        denomination.amount = "";
        denomination.faceValue = "";
    } else {
        const isMultiPackable = type === 'remainingMultiDenominations' || type === 'remainingAtmDenominations';
        let nextIndex = this.newCash[type].findIndex((item) => item.faceValue > denomination.faceValue && item.id === denomination.icon && item.multiDenomPackable === isMultiPackable);
        do {
            nextIndex += 1;
        } while (
            nextIndex < this.newCash[type].length &&
            this.newCash[type][nextIndex].multiDenomPackable !== isMultiPackable
        );

        if (nextIndex < this.newCash[type].length) {
            const nextDenomination = this.newCash[type][nextIndex];
            denomination.icon = nextDenomination.id;
            denomination.faceValue = nextDenomination.faceValue;
            denomination.sortOrder = nextDenomination.sortOrder;
            denomination.coinFlag = nextDenomination.coinFlag;
            denomination.shiptypeId = nextDenomination.shiptypeId;
        }
        if (this.newCash.orderType === 'P' || this.newCash.orderType === 'T') {
          denomination.amount = 0;
          denomination.billCount = 0;
        }
    }

    this.calculateDenominationAmount(type === 'remainingDenominations' ? 'denominations' : 'multiDenominations');
    if (this.newCash.orderType === 'P' || this.newCash.orderType === 'T') this.validateBillCount();
    this.removeUsedDenoms();

    if (type === 'remainingDenominations') {
      this.checkSingleDenomCoinShiptype();
    }
}



  removeDenomination(index, denomData) {
    this.newCash.denominations.splice(index, 1);
  }

  removeAlreadyUsedDenom(_type, remainingDenomModelKey) {
    // Create a Set of used icons for more reliable filtering
    const usedIcons = new Set();
    
    // Collect all enabled icons
    if (this.newCash[_type] && Array.isArray(this.newCash[_type])) {
      this.newCash[_type].forEach(data => {
        if (data.isEnabled && data.icon) {
          usedIcons.add(data.icon);
        }
      });
    }
    
    // Filter out denominations that have icons already in use
    this.newCash[remainingDenomModelKey] = this.denominationAllType.filter(type => {
      return !usedIcons.has(type.id);
    });
  }

  turnOffDenom(denomination, denomIndex, type) {//= 'denominations'

    if(denomination.multiDenomPackable && type==='multiDenominations') {
    this.multiDenomIndex = this.multiDenomIndex-1;
    } else if ((!denomination.multiDenomPackable) && type==='denominations') {
    this.singleDenomIndex = this.singleDenomIndex-1;
    } else if (type==='atmDenominations') {
      this.atmDenomIndex = this.atmDenomIndex-1;
    }
    denomination.isEnabled = false;
    denomination.billCount = null;
    denomination.amount = null;

    if ('isDeleted' in denomination) {
      denomination.isDeleted = true;
  }

    let cursor = 0;
    this.newCash[type].forEach(d => {
      if (!d.isEnabled) cursor++;
      else cursor = 0;
    });
    if (this.newCash[type].length === cursor) {
      this.isValidBillCount = true;
    }
    this.validateBillCount();

    if(type==='denominations') {
      denomination.isValid = false;
      this.newCash.denominations.sort((a, b) => {
        return b.isEnabled - a.isEnabled;
    });
    this.checkSingleDenomCoinShiptype();
  } else if(type==='multiDenominations') {
    denomination.isValid = false;
    this.newCash.multiDenominations.sort((a, b) => {
      return b.isEnabled - a.isEnabled;
  });
  } else if(type==='atmDenominations') {
    denomination.isValid = false;
    this.newCash.atmDenominations.sort((a, b) => {
      return b.isEnabled - a.isEnabled;
  });
  }

    this.calculateDenominationAmount();
    this.removeUsedDenoms();
  }

  //load filters data list
  loadUserBranches() {
    this.ServiceOrderService.getUserBranchList(this.User.getUser().id)
      .then(res => {
        this.filterDataSet.userBranches = res.results;
        this.filterDataSet.userBranches.forEach(branch => {
          if (branch.branchId == this.branchId) {
            this.filterDataSet.currentVaultDate = moment.utc(branch.currentVaultDate).format("YYYY-MM-DD");
            branch.ticked = true;
          }
        });
      })
      .catch(err => {
        console.log(err);
      });
  }

  userBranchMap(branches) {
    return branches.map(branch => {
      return {
        Key: branch.branchId,
        Value: branch.branchId,
      };
    });
  }

  generateSearchObj(searchKey) {
    searchKey = searchKey || "";

    const branchId = this.getSelectedBranches();
    const obj = {
      queryJSON: {
        rules: [
          {
            field: "branchId",
            condition: "IN",
            data: branchId && branchId.length ? branchId : [this.branchId],
          },
          {
            group: {
              rules: [
                {
                  field: "id",
                  condition: "like",
                  data: "%" + searchKey + "%",
                },
                {
                  field: "sourceName",
                  condition: "like",
                  data: "%" + searchKey + "%",
                },
              ],
              operator: "OR",
            },
          },
        ],
        operator: "AND",
      },
    };
    return obj.queryJSON.rules.length ? obj : null;
  }

  getAllFundingSource(searchKey, offset) {
    this.isLoading = true;

    if (this.customerUser) {
      this.UserBranchFundingSourceService.getBranchFundingSource(this.userDetails.id, this.branchId)
        .then(data => {
          this.filterDataSet.totalBranchFundingSource = data.total;
          this.filterDataSet.branchFundingSource = this.mappingData(data.results, "sourceName", "id");
        })
        .catch(err => {
          err.data && err.data.message ? this.Modal.errorModal(err.data.message) : console.error(err)
        })
        .finally(() => {
          this.isLoading = false;
        });
      return;
    }

    const searchObj = this.generateSearchObj(searchKey);

    this.BranchFundingSourceService.all(searchObj, offset, AppConstants.defaultPageLimit)
      .then(data => {
        if (offset === 0 || offset == undefined) {
          this.filterDataSet.totalBranchFundingSource = data.total;
          this.filterDataSet.branchFundingSource = this.mappingData(data.results, "sourceName", "id");
        } else {
          const fundingSource = this.mappingData(data.results, "sourceName", "id");
          this.filterDataSet.branchFundingSource = this.filterDataSet.branchFundingSource.concat(fundingSource);
        }
      })
      .catch(err => {
       err.data && err.data.message ? this.Modal.errorModal(err.data.message) : console.error(err)
      })
      .finally(() => {
        this.isLoading = false;
      });
  }

  customerSearchPaginate(searchKey, idKey, nameKey) {
    return {
      queryJSON: {
        rules: [
          {
            field: idKey,
            condition: "like",
            data: "%" + searchKey + "%",
          },
          {
            field: nameKey,
            condition: "like",
            data: "%" + searchKey + "%",
          },
        ],
        operator: "OR",
      },
    };
  }

  getCustomer(searchKey, offset) {
    searchKey = searchKey || "";
    let costomerSearchObj = this.customerSearchPaginate(searchKey, "id", "name");
    if (!searchKey) {
      costomerSearchObj.queryJSON.rules = [];
      costomerSearchObj.queryJSON.operator = "AND";
    }
    if (this.customerUser) {
      costomerSearchObj.queryJSON.rules.push({
        field: "id",
        condition: "=",
        data: this.customerUser,
      });
    }

    if (offset !== 0 && !searchKey && Math.abs(offset % 2) === 1) {
      offset = offset - 1;
    }
    return this.CustomerService.all(costomerSearchObj, offset, AppConstants.defaultPageLimit)
      .then(res => {
        let selectedVal = this.model.customer ? this.model.customer.Value : "";
        if (offset === 0 || offset == undefined) {
          this.filterDataSet.totalCustomer = res.total;
          let customers = this.mappingData(res.results, "name", "id");
          // if (!searchKey && selectedVal) {
          // 	customers.unshift(this.model.customer);
          // }
          this.filterDataSet.customerList = _.uniqBy(customers, "Value");
        } else {
          const customers = this.mappingData(res.results, "name", "id");
          this.filterDataSet.customerList = _.uniqBy(this.filterDataSet.customerList.concat(customers), "Value");
        }
      })
      .catch(err => {
        if (err && err.data && err.data.message) {
          this.errorMessage = err.data.message;
        }
      });
  }

  filterOrderTypes() {
    if (this.$currentTab === 'cashDeliveries') {
      this.filterDataSet.shipTypes = [];
      const [shipType] = this.shiptypeList.filter(st => st.id === 'COD');
      if (shipType) {
        this.filterDataSet.shipTypes.push({
          key: shipType.description,
          value: shipType.id
        })
      }
    } else {
      this.filterDataSet.orderTypes = this.CommonLayoutService.orderTypes().filter(orderType => orderType.value !== 'X' || orderType.value !== 'COD');
      if (this.customerUser) {
        this.filterDataSet.orderTypes = this.filterDataSet.orderTypes.filter(o => o.value === 'A' || o.value === 'S');
      }
    }
  }

  isHoldRoute(route) {
    if (!route) return false;
    let routeId = route.Value ? route.Value : route;
    if (this.filterDataSet && this.filterDataSet.routeList) {
      let routeObj = this.filterDataSet.routeList.find(r => r.Value === routeId);
      if (routeObj && routeObj.dataObj && routeObj.dataObj.holdRoute) {
        return true;
      }
    }
    
    return false;
  }

  locationSearchObj(searchKey, forMainPage = false) {
    const tabType = this.$currentTab
    searchKey = searchKey || "";
    const branchId = this.getSelectedBranches();  
    const searchObj = {
      queryJSON: {
        rules: [
          {
            field: "branchId",
            condition: "IN",
            data: branchId && branchId.length ? branchId : [this.branchId],
          },
          {
            field: "active",
            condition: "=",
            data: true,
          },
          {
            group: {
              rules: [
                {
                  field: "id",
                  condition: "like",
                  data: "%" + searchKey + "%",
                },
                {
                  field: "name",
                  condition: "like",
                  data: "%" + searchKey + "%",
                },
              ],
              operator: "OR",
            },
          },
        ],
        operator: "AND",
      },
    };
  
    // Add locationType rules based on tab type
    if (tabType === 'cashDeliveries') {
      if (!forMainPage && this.newCash && this.newCash.fundingSource && this.newCash.fundingSource.Value) {
        searchObj.queryJSON.rules.push({
          field: "bankSourceId",
          condition: "=",
          data: this.newCash.fundingSource.Value,
        });
        searchObj.queryJSON.rules.push({
          group: {
            rules: [
              { field: "locationType", condition: "=", data: "REGULAR" },
              { field: "locationType", condition: "=", data: "ON_CALL" },
              { field: "locationType", condition: "=", data: "NO_SHIP_NO_GO" },
              { field: "locationType", condition: "=", data: "BANK" },
            ],
            operator: "OR",
          },
        });
      }
    }
    if (tabType === 'cashCoin') {
      searchObj.queryJSON.rules.push({
        group: {
          rules: [
            {
              field: "locationType",
              condition: "=",
              data: "REGULAR",
            },
            {
              field: "locationType",
              condition: "=",
              data: "ON_CALL",
            },
            {
              field: "locationType",
              condition: "=",
              data: "NO_SHIP_NO_GO",
            },
            {
              field: "locationType",
              condition: "=",
              data: "BANK",
            },
          ],
          operator: "OR",
        },
      });
    } else if (tabType === 'ATMOrders' || tabType === 'atmLoad') {
      searchObj.queryJSON.rules.push({
        field: "locationType",
        condition: "=",
        data: "ATM",
      });
    }

    if (!forMainPage && (tabType === 'cashDeliveries' || tabType === 'ATMOrders' || tabType === 'atmLoad')
        && this.newCash && this.newCash.fundingSource && this.newCash.fundingSource.Value) {
      searchObj.queryJSON.rules.push({
        field: 'bankSourceId',
        condition: '=',
        data: this.newCash.fundingSource.Value
      });
    }

    if (forMainPage && this.model && this.model.fundingSourceId && this.model.fundingSourceId.Value) {
      searchObj.queryJSON.rules.push({
        field: 'bankSourceId',
        condition: '=',
        data: this.model.fundingSourceId.Value
      });
    }
  
    if (this.customerUser) {
      searchObj.queryJSON.rules.push({
        field: "customerId",
        condition: "=",
        data: this.customerUser,
      });
    }
  
    return searchObj.queryJSON.rules.length ? searchObj : null;
  }
  
  onMainFundingSourceSelected() {
    this.mainPageFilters.locationList = [];
    this.mainPageFilters.totalLocation = 0;
    this.mainPageFilters.offset = 0;
    if(this.filter.locationId) this.filter.locationId = null;
    this.loadLocation('', 0, true);
    if (typeof this.filterOrderView === 'function') {
      this.filterOrderView();
    }
  }

  fetchLocationsOnEvent(searchKey) {
    searchKey = searchKey || "";
    
    const locationSearchObj = this.locationSearchObj(searchKey);
    this.LocationService.all(locationSearchObj, 0, AppConstants.defaultPageLimit)
      .then(res => {
        this.filterDataSet.totalLocation = res.total;
        this.filterDataSet.locationList = this.mappingData(res.results, "name", "id");
      })
      .catch(err => {
        console.log(err);
      });
  }
  

 loadLocation(searchKey, offset, forMainPage = false) {
 searchKey = searchKey || "";
 
 if (!forMainPage && (this.$currentTab === 'cashDeliveries' || this.$currentTab === 'ATMOrders' || this.$currentTab === 'atmLoad')
      && (!this.newCash || !this.newCash.fundingSource || !this.newCash.fundingSource.Value)) {
    if (offset === 0) {
      this.filterDataSet.totalLocation = 0;
      this.filterDataSet.locationList = [];
    }
    return this.$q.resolve();
  }

  const locationSearchObj = this.locationSearchObj(searchKey, forMainPage);
  this.LocationService.all(locationSearchObj, offset, AppConstants.defaultPageLimit)
    .then(res => {
      if (offset === 0) {
       if (forMainPage) {
         this.mainPageFilters.totalLocation = res.total;
         this.mainPageFilters.locationList = this.mappingData(res.results, "name", "id");
         this.mainPageFilters.offset = offset;
       } else {
        this.filterDataSet.totalLocation = res.total;
        this.filterDataSet.locationList = this.mappingData(res.results, "name", "id");
       }
      } else {
        const locations = this.mappingData(res.results, "name", "id");
       if (forMainPage) {
         this.mainPageFilters.locationList = this.mainPageFilters.locationList.concat(locations);
         this.mainPageFilters.offset = offset;
       } else {
        this.filterDataSet.locationList = this.filterDataSet.locationList.concat(locations);
       }
     }
   })
   .catch(err => {
     console.log(err);
   });
}

  

  getActiveRoutes(searchKey, offset) {
    searchKey = searchKey || "";

    const branchId = this.getSelectedBranches();
    const routeSearchObj = {
      queryJSON: {
        rules: [
          {
            field: "branchId",
            condition: "IN",
            data: branchId && branchId.length ? branchId : [this.branchId],
          },
          {
            field: "active",
            condition: "=",
            data: true,
          },
          {
            group: {
              rules: [
                {
                  field: "id",
                  condition: "like",
                  data: "%" + searchKey + "%",
                },
                {
                  field: "name",
                  condition: "like",
                  data: "%" + searchKey + "%",
                },
              ],
              operator: "OR",
            },
          },
        ],
        operator: "AND",
      },
    };

    // this.RouteService.getActiveRoutes(this.branchId, selectedDate)
    return this.RouteService.all(routeSearchObj, 0, this.MAXLIMIT)
      .then(res => {
        if (this.branchHoldRoute && this.model.currentStats === this.shipmentsCreateStats.prePacked.all) {
          res.results.unshift({ id: "HOLD", name: "HOLD" });
        }

        const routes = this.mappingData(res.results, "name", "id");
        this.filterDataSet.routeList = routes;
        this.filterDataSet.totalRoutes = routes.length;
        if(this.newCash.toLocation && this.newCash.fundingSource && this.filterDataSet.routeList.length === 1){
          this.newCash.routeId = this.filterDataSet.routeList[0]
        }
      })
      .catch(err => {
        console.log(err);
      });
  }

  mappingData(arr, label, value) {
    return arr.map(item => {
      const arrayObject = {
        Key: item[value] + " | " + item[label],
        Value: item[value],
        dataObj: item,
      };

      return arrayObject;
    });
  }

  sortCollection(column) {

    if (this.sortColumn === column) {
        this.reverseSort = !this.reverseSort;
    } else {
        this.sortColumn = column;
        this.reverseSort = false;
    }
    this.allOrders = this.allOrders.sort((a, b) => {
        let valueA = a[column];
        let valueB = b[column];

        if (valueA === null || valueA === undefined) valueA = '';
        if (valueB === null || valueB === undefined) valueB = '';

        if (typeof valueA === 'string') {
            valueA = valueA.toLowerCase();
            valueB = valueB.toLowerCase();
        }
        if (valueA < valueB) {
            return this.reverseSort ? 1 : -1;
        }
        if (valueA > valueB) {
            return this.reverseSort ? -1 : 1;
        }
        return 0; 
    });
};

  getAtmOrders() {
    this.model.gettingServiceOrder = true;
    setTimeout(() => {
      const startDate = this.getStartDate();
      const endDate = this.getEndDate();
      const fundingSourceId = this.model.fundingSourceId ? this.model.fundingSourceId.Value : null;
      const customerId = this.filter.customerId ? this.filter.customerId.Value : null;
      const locationId = this.filter.locationId ? this.filter.locationId.Value : null;
      const orderType = this.filter.orderType;
      const routeId = this.model.routeId ? this.model.routeId.Value : null;
      const status = this.model.status ? this.model.status.Value : null;
      const denominationId = this.getSelectedDenoms();
      const branchId = this.getSelectedBranches();
      const searchText = this.searchText;
      this.collection = {};
      this.sortColumn = ''; 
      this.reverseSort = false;
      
      this.OrderViewService.getAtmOrders(
        searchText,
        branchId,
        startDate,
        endDate,
        this.currentOrderStat,
        fundingSourceId,
        customerId,
        locationId,
        orderType,
        routeId,
        status,
        denominationId
      )
        .then(data => {
          this.allOrders = [];

          const orderNoGrp = _.groupBy(data.results, item => {
            const isScheduled = item.type === 'scheduledATMLoadOrders' || item.type === 'scheduledPackableOrder';

            if (isScheduled) {
              const safeDate = item.serviceDate ? moment.utc(item.serviceDate).format('YYYY-MM-DD') : 'UNSCHEDULED';
              const loc = item.toLocationId || 'UNKNOWN_LOC';

              return `ATM_${loc}_${safeDate}`;
            }

            const order = item.orderNo || 'NO_ORDER';
            const job = item.jobId || 'NO_JOB';
            const batch = item.batchId || 'NO_BATCH';
            const loc = item.toLocationId || 'UNKNOWN_LOC';

            if (!item.orderNo && !item.jobId && !item.batchId) {
              const safeDate = item.serviceDate ? moment.utc(item.serviceDate).format('YYYY-MM-DD') : 'UNSCHEDULED';
              return `INDIVIDUAL_${loc}_${safeDate}`;
            }

            return `${order}_${job}_${batch}_${loc}`;
          });

          const keys = Object.keys(orderNoGrp);
          let groupedData = keys.map(key => {
            const group = orderNoGrp[key];
            const firstItem = group[0];

            const hasDenominations = group.some(obj => obj.denominationId != null && obj.orderNo != null);

            return {
              orderNo: firstItem.orderNo || null,
              jobId: firstItem.jobId || null,
              batchId: firstItem.batchId || null,
              serviceDate: firstItem.serviceDate ? moment.utc(firstItem.serviceDate).format('YYYY-MM-DD') : null,

              shipments: Array.from(
                new Map(
                  group
                    .filter((order) => order.status === 'scheduled' || !((order.coinFlag === 0 && order.batchId) || (order.bagSeal == null && order.status !== 'pendingPack' && order.isPackableOrder !== 1)))
                    .map((order) => {
                      return {
                        ...order,
                        denominationId: order.denominationId
                          ? order.denominationId
                          : (order.trackingIdDelivery && order.trackingIdDelivery.split('-').length > 1)
                            ? order.trackingIdDelivery.split('-').pop()
                            : null,
                      };
                    }).map((order) => [`${order.trackingIdDelivery}-${order.denominationId}`, order])
                ).values()
              ),

              ...firstItem,

              cashShipmentAmount: group.reduce((sum, obj) => {
                if (hasDenominations && obj.denominationId == null && obj.orderType !== 'COD') return sum;
                return obj.coinFlag === 0 ? sum + obj.amount : sum;
              }, 0),

              coinShipmentAmount: group.reduce((sum, obj) => {
                if (hasDenominations && obj.denominationId == null && obj.orderType !== 'COD') return sum;
                return obj.coinFlag === 1 ? sum + obj.amount : sum;
              }, 0),

              amount: group.reduce((sum, obj) => {
                if (hasDenominations && obj.denominationId == null && obj.orderType !== 'COD') return sum;
                return sum + obj.amount;
              }, 0),

              denominations: group
                .map((order) => {
                  let denomObj = null;
                  if (order.denominationId) {
                    denomObj = this.allDenoms.find(denom => denom.id === order.denominationId);
                  } else if (order.trackingIdDelivery) {
                    const trackingIdParts = order.trackingIdDelivery.split('-');
                    const lastTrackingId = trackingIdParts[trackingIdParts.length - 1];
                    denomObj = this.allDenoms.find(denom => denom.id === lastTrackingId);
                  } else if (order.status === 'scheduled' && order.denominationId == null) {
                    denomObj = this.allDenoms.find(denom => denom.id === order.shiptypeId);
                  }

                  if (denomObj) {
                    return {
                      isEnabled: !!denomObj,
                      icon: denomObj.id || null,
                      id: denomObj.id || null,
                      faceValue: denomObj ? denomObj.faceValue : 0,
                      amount: order.amount,
                      template: !order.isPackableOrder
                        ? "order-view-atm-denomination-selection.html"
                        : (order.isPackableOrder && order.multiDenomPackable)
                          ? "order-view-multi-denomination-selection.html"
                          : "order-view-denomination-selection.html",
                      dollarFlag: true,
                      duplicate: false,
                      strapCount: denomObj.strapCount,
                      multiDenomPackable: order.multiDenomPackable,
                      coinFlag: denomObj ? denomObj.coinFlag : false,
                      sortOrder: denomObj ? denomObj.sortOrder : 0,
                      shiptypeId: denomObj ? denomObj.shiptypeId : null,
                      billCount: denomObj ? Math.floor(order.amount / denomObj.faceValue) : 0,
                      isValid: true,
                      status: order.status || null,
                    };
                  }
                }).filter(Boolean).sort((a, b) => (a.sortOrder - b.sortOrder) || (a.faceValue - b.faceValue)),

              coinShipments: group
                .filter((order) => order.coinFlag === 1 && order.batchId)
                .map((order) => {
                  return {
                    ...order,
                    shiptypeId: order.denominationId || order.shiptypeId
                  };
                }),

              trackingIds: [...new Set(group
                .filter(order => order.trackingIdDelivery)
                .map(order => order.trackingIdDelivery))],

              parentTrackingId: (function () {
                const foundOrder = group.find(order => order.parentTrackingId);
                return foundOrder ? foundOrder.parentTrackingId : null;
              })(),

              fundingSource: firstItem.fundingSource,
              type: firstItem.type || 'none',
              formatAddress: firstItem.toLocationName + " | " +
                (firstItem.toLocationAddress || '') + " " +
                (firstItem.toLocationCity || '') + " " +
                (firstItem.toLocationState || ''),
            };
          });

        if(this.$currentViewTab=='calender'){
          groupedData.forEach(d => {
              this.collection[moment.utc(d.serviceDate).format("YYYY-MM-DD")] = {
                  total: 0,
                  collections: [],
                  totalPackedShipments: 0,
                  totalPendingPackShipments: 0,
                  totalRecords: 0,
              };
          });
          groupedData.forEach((d, index) => {
            let dataObj = this.collection[moment.utc(d.serviceDate).format("YYYY-MM-DD")];
            if (d.orderNo == null || !d.deliveredFlag) {
              dataObj.total += d.amount;
            } else if (d.orderNo !== null && d.deliveredFlag) {
              dataObj.total += d.loadedAmount;
            }
            dataObj.totalRecords++;

            if (d.status === "packed") dataObj.totalPackedShipments++;
            else if (d.status === "pendingPack") dataObj.totalPendingPackShipments++;

            dataObj.collections.push({
              status: d.status,
              orderNo: d.orderNo,
              orderType: d.orderType,
              serviceDate: d.serviceDate,
              amount: d.amount,
              toLocationId: d.toLocationId,
              toLocationName: d.toLocationName,
              routeId: d.routeId,
              routeName: d.routeName,
              denominationId: d.denominationId,
              trackingIdDelivery: d.trackingIdDelivery,
              shipments: d.shipments || [],
              packedFlag: d.packedFlag,
              toLocationType: d.toLocationType,
              batchId: d.batchId,
              coinShipments: d.coinShipments || [],
              shiptypeId: d.shiptypeId,
              coinShipmentAmount: d.coinShipmentAmount,
              cashShipmentAmount: d.cashShipmentAmount,
              fundingSourceId: d.fundingSourceId,
              fundingSourceName: d.fundingSourceName,
              fundingSource: d.fundingSource,
              trackingIds: d.trackingIds,
              loadedAmount: d.loadedAmount,
              deliveredFlag: d.deliveredFlag,
              cashOrderId: d.cashOrderId,
              denominations: d.denominations,
              fetchedDenominations: d.denominations,
              shipmentId: d.loadShipmentId,
              jobKey: d.jobKey || null,
              jobId: d.jobId || null,
              scheduleWeekDays: d.scheduleWeekDays || null,
              recurringFrequency: d.recurringFrequency || null,
              recurringDayInterval: d.recurringDayInterval || null,
              frequencyWeek: d.frequencyWeek || null,
              locationScheduleRecurringId: d.locationScheduleRecurringId || null,
              isEC: d.isEC,
              editAmount: d.editAmount,
              isPackableOrder: d.isPackableOrder || 0,
              formatAddress: d.formatAddress || null,
              type: d.type,
              parentTrackingId: d.parentTrackingId || null,
            });
          });
        } else{
          groupedData.forEach((d, index) => {
            this.allOrders.push({
              status: d.status,
              orderNo: d.orderNo,
              orderType: d.orderType,
              serviceDate: d.serviceDate,
              amount: d.amount,
              toLocationId: d.toLocationId,
              toLocationName: d.toLocationName,
              routeId: d.routeId,
              routeName: d.routeName,
              denominationId: d.denominationId,
              trackingIdDelivery: d.trackingIdDelivery,
              shipments: d.shipments || [],
              packedFlag: d.packedFlag,
              toLocationType: d.toLocationType,
              batchId: d.batchId,
              coinShipments: d.coinShipments || [],
              shiptypeId: d.shiptypeId,
              coinShipmentAmount: d.coinShipmentAmount,
              cashShipmentAmount: d.cashShipmentAmount,
              fundingSourceId: d.fundingSourceId,
              fundingSourceName: d.fundingSourceName,
              fundingSource: d.fundingSource,
              trackingIds: d.trackingIds,
              loadedAmount: d.loadedAmount,
              deliveredFlag: d.deliveredFlag,
              cashOrderId: d.cashOrderId,
              denominations: d.denominations,
              fetchedDenominations: d.denominations,
              shipmentId: d.loadShipmentId,
              jobKey: d.jobKey || null,
              jobId: d.jobId || null,
              scheduleWeekDays: d.scheduleWeekDays || null,
              recurringFrequency: d.recurringFrequency || null,
              recurringDayInterval: d.recurringDayInterval || null,
              frequencyWeek: d.frequencyWeek || null,
              locationScheduleRecurringId: d.locationScheduleRecurringId || null,
              isEC: d.isEC,
              editAmount: d.editAmount,
              isPackableOrder: d.isPackableOrder || 0,
              formatAddress: d.formatAddress || null,
              type: d.type,
              branchId: d.branchId,
              parentTrackingId: d.parentTrackingId || null,
            });
          })
            this.sortCollection('serviceDate');
        }
        })
        .catch(err => {
          if (err && err.data && err.data.message) {
            this.Modal.errorModal(err.data.message);
          }
        })
        .finally(() => {
          this.onDateSelect(null);
          this.model.gettingServiceOrder = false;
          setTimeout(() => {
            const el = document.getElementById('masterCashSearch');
            if (el) el.focus();
          }, 100);
        });
      });
  }

  getStartDate() {
    return this.dateRangeOptions.startDate ? moment(this.dateRangeOptions.startDate).format("YYYY-MM-DD") : null;
  }

  getEndDate() {
    return this.dateRangeOptions.endDate ? moment(this.dateRangeOptions.endDate).format("YYYY-MM-DD") : null;
  }

  setStartDate(input) {
    if (!input) return;
    
    const startDate = this.$currentViewTab === 'calender' 
      ? moment(input, "MM-YYYY").startOf("month") 
      : moment(this.branchCurrentVaultDate);  
  
    this.dateRangeOptions = { startDate: startDate };
  }

  setEndDate(input) {
    if (!input) return;
    const endDate = this.$currentViewTab === 'calender' 
      ? moment(input, "MM-YYYY").endOf("month") 
      : moment(this.branchCurrentVaultDate).add(7, 'days');  
  
    this.dateRangeOptions.endDate = endDate;
  }

  goToRouteTab(data) {
    const obj = {
        routeId: data.routeId,
        vaultDate: data.serviceDate,
        isRedirected: true
    }
    this.DataCounter.setData(obj);
    this.$state.go('branchManagement.routes');
}
  
goToServiceHistory(data) {
 
  if (data && data.toLocationId && data.orderNo && data.status === 'pendingPack') {
    let fundingSourceId = data.fundingSourceId ? data.fundingSourceId : (this.model.locationId && this.model.locationId.Value);
    this.Navigation.goToOrderPackingFromLocation(data.toLocationId, data.orderNo, fundingSourceId);
  } else {
    const obj = {
        locationId: data.toLocationId,
        vaultDate: null,
        isRedirected: true
    }
    this.DataCounter.setData(obj);
    this.$state.go('branchManagement.locations');
  }
}

goToItemHistory(trackingId) {
  this.$state.go('branchManagement.items', {
    id: trackingId,
  });
}

  scrollToTop() {
    return window.scrollTo({ top: 0, behavior: "smooth" });
  }

  getOrderStats(value) {
    if(value==this.orderStatObj.All){
      this.currentOrderStat=null
    }else{
    this.currentOrderStat = this.currentOrderStat === value ? null : value;
    }
    let id;
    switch (value) {
      case this.orderStatObj.atRisk:
        id = "at-risk";
        break;
      case this.orderStatObj.ATM:
        id = "atm";
        break;
      case this.orderStatObj.Cash:
        id = "cash";
        break;
      case this.orderStatObj.Scheduled:
        id = "scheduled";
        break;
      case this.orderStatObj.All:
        id= "all";
        break;
    }
    // const id = value === this.orderStatObj.atRisk ? 'at-risk' : this.orderStatObj.ATM ? 'atm' : this.orderStatObj.Cash ? 'cash' : 'scheduled';
    document.getElementById(id).blur();
    this.filterOrderView();
    // if (this.currentOrderStat !== this.orderStatObj.Scheduled) this.getAtmOrders();
  }

  resetDateRange() {
    if(this.$currentViewTab=='calender'){
    this.dateRangeOptions = {
      startDate: moment().startOf("month"),
      endDate: moment().endOf("month"),
    };
  }else {
    this.dateRangeOptions = {
      startDate: moment(this.branchCurrentVaultDate),            
      endDate: moment(this.branchCurrentVaultDate).add(7, 'days'), 
    };
  }
  }

  getSelectedBranches() {
    return Array.isArray(this.model.selectedBranch) ? this.model.selectedBranch.map(branch => branch.branchId) : null;
  }

  getSelectedDenoms() {
    return Array.isArray(this.filter.selectedDenoms) ? this.filter.selectedDenoms.map(denom => denom.Value) : null;
  }

  openOrderDetailsModal(date) {
    if (!this.collection || !this.collection[date] || !this.collection[date].collections || this.collection[date].collections.length === 0) {
      return;
    }
    const collections = this.collection[date].collections;
    const totalAmount = this.collection[date].total;
    const denomTotals = {};
    
    collections.forEach(order => {
      if (order.denominations && order.denominations.length) {
        order.denominations.forEach(denom => {
           if (denom.id) {
             if (!denomTotals[denom.id]) {
                 denomTotals[denom.id] = 0;
             }
             denomTotals[denom.id] += denom.amount || 0;
           }
        });
      }
    });

    // Order the denom totals by DB sort order so they display in sequence.
    const orderedDenomTotals = _.orderBy(
      Object.keys(denomTotals).map(id => {
        const denomObj = this.allDenoms.find(d => d.id === id);
        return {
          id,
          amount: denomTotals[id],
          sortOrder: denomObj ? denomObj.sortOrder : 999
        };
      }),
      ["sortOrder"],
      ["asc"]
    );

    if (this.Modal.masterCashOrderDetailsModal) {
       this.Modal.masterCashOrderDetailsModal(date, collections, totalAmount, orderedDenomTotals);
    }
  }

  filterOrderView() {
    this._calendar.isEdit = false;
    this._calendar.isNew = false;
    this.getAtmOrders();
  }

  resetDataOnBranchChange() {
    setTimeout(() => {
      this.model.fundingSourceId = null;
      this.filter.locationId = null;
      this.getAllFundingSource("", 0);
      this.loadLocation("", 0);
      this.loadFromLocation("", 0);
    });
  }

  resetFilter() {
    this.model.status = null;
    this.searchText = null;
    this.currentOrderStat = null;
    this.model.routeId = null;
    this.model.fundingSourceId = null;
    this.filter.locationId = null;
    if (this.userDetails.customerUser) {
      const customerDetails = _.find(this.filterDataSet.customerList, { Value: this.userDetails.customerId });
      this.filter.customerId = customerDetails;
    } else {
      this.filter.customerId = null;
    }
    this.filter.orderType = null;
    this.filter.selectedDenoms = [];
    this.setStartDate(this.formattedSelectedMonth);
    this.setEndDate(this.formattedSelectedMonth);
    this.filterDataSet.userBranches.forEach(branch => {
      branch.ticked = false;
      if (branch.branchId == this.branchId) {
        this.filterDataSet.currentVaultDate = moment.utc(branch.currentVaultDate).format("YYYY-MM-DD");
        branch.ticked = true;
      }
    });

    this.istevenMultiSelectLocalLang.nothingSelected = "Select Denomination"; 
    this.filterDataSet.denomsList.forEach(denom => {
      denom.ticked = false;
    });
    this.filterOrderView();
  }

  goToItemHistory(trackingId) {
    this.Navigation.goToItemHistory(trackingId, null);
  }

  changeCoinType(event, type, coin) {
    this.coinTypes[type].selected = coin;
    this.coinTypes[type].isOpen = false;
    this.getCurrency();
    this.getCurrencyTotal();
  }

  getCurrencyTotal() {
    // const cashAmount = this.newCash.cashAmount;
    // const coinAmount = this.newCash.coinAmount;
    // this.newCash.totalAmount = cashAmount + coinAmount;

    if(this.newCash.isPackableOrder){
      const allDenominations = [...this.newCash.multiDenominations, ...this.newCash.denominations];

      let cashShipmentAmount = 0;
      let coinShipmentAmount = 0;

      allDenominations.forEach(denomination => {
        if (denomination.isEnabled) {
          if (denomination.coinFlag) {
            coinShipmentAmount += denomination.amount || 0;
          } else {
            cashShipmentAmount += denomination.amount || 0;
          }
        }
      });

      this.newCash.cashShipmentAmount = cashShipmentAmount;
      this.newCash.coinShipmentAmount = coinShipmentAmount;
    }else {
      let cashFromDenoms = 0;
      let coinFromDenoms = 0;
      this.newCash.atmDenominations
        .filter(denomination => denomination.isEnabled)
        .forEach(denomination => {
          const amt = denomination.amount || 0;
          if (denomination.coinFlag) coinFromDenoms += amt; else cashFromDenoms += amt;
        });
      if (cashFromDenoms > 0) {
        this.newCash.cashShipmentAmount = cashFromDenoms;
      }
      if (coinFromDenoms > 0) {
        this.newCash.coinShipmentAmount = coinFromDenoms;
      }
    }
  }

  getCurrency() {
    let coinsTotal = 0;
    const coinKeys = Object.keys(this.coinTypes);
    coinKeys.forEach(coinKey => {
      if (!this.coinTypes[coinKey]) return;
      const coinType = this.coinTypes[coinKey].selected;
      const categoryName = this.coinTypes[coinKey].categoryName;
      if (this.newCash.coinShipmentObj[categoryName] >= 0) {
        coinsTotal += this.newCash.coinShipmentObj[categoryName] * this.getCoinValue(coinType);
        this.newCash.coinAmount = coinsTotal;
      }
    });
    if(this.newCash.cashAmount){
      this.newCash.totalAmount = this.newCash.cashAmount + coinsTotal;
    }else {
      this.newCash.totalAmount = coinsTotal;
    }
  }

  getCoinValue(coinType) {
    return this.coinValues[coinType].amountFlag ? this.coinValues[coinType].amount : this.coinValues[coinType].unitValue;
  }

  loadFromLocation(searchKey, offset) {
    searchKey = searchKey || "";

    const branchId = this.getSelectedBranches();
    const searchObj = {
      queryJSON: {
        rules: [
          { field: "branchId", condition: "=", data: branchId && branchId.length ? branchId : [this.branchId] },
          { field: "active", condition: "=", data: true },
          {
            group: {
              rules: [
                { field: "locationType", condition: "=", data: "ATM" },
                { field: "locationType", condition: "=", data: "BANK" },
                { field: "locationType", condition: "=", data: "REGULAR" },
                { field: "locationType", condition: "=", data: "ON_CALL" },
                { field: "locationType", condition: "=", data: "NO_SHIP_NO_GO" },
                { field: "locationType", condition: "=", data: "DELIVERY" },
                { field: "locationType", condition: "=", data: "INTERNAL" },
                {
                  field: "centralBank",
                  condition: "=",
                  data: true,
                },
              ],
              operator: "OR"
            }
          },
          {
            group: {
              rules: [
                {
                  field: "id",
                  condition: "like",
                  data: "%" + searchKey + "%",
                },
                {
                  field: "name",
                  condition: "like",
                  data: "%" + searchKey + "%",
                },
              ],
              operator: "OR",
            },
          },
        ],
        operator: "AND"
      }
    };

    if (this.customerUser) {
      searchObj.queryJSON.rules.push({
        field: "customerId",
        condition: "=",
        data: this.customerUser,
      });
    }

    this.LocationService.all(searchObj, offset, AppConstants.defaultPageLimit).then(data => {
      if (offset === 0 || offset == undefined) {
        this.fromLocationObj.totalRecords = data.total;
        this.fromLocationObj.results = this.mappingLocData(data.results);
      } else {
        const locations = this.mappingLocData(data.results);
        this.fromLocationObj.results = this.fromLocationObj.results.concat(locations);
      }
    });
  }

  mappingLocData(list) {
    return list.map(loc => {
      return {
        Key: loc.id + " | " + loc.name,
        Value: loc.id,
      };
    });
  }

  createCashDeliveries() {
    const dtFormat = "YYYY-MM-DD";
    const obj = this.newCash;
    const shipments = [];
    const days = { 0: "Sun", 1: "Mon", 2: "Tue", 3: "Wed", 4: "Thu", 5: "Fri", 6: "Sat" };
    const selectedDay = days[moment(obj.vaultDate).day()];
    const seqKey = "defRouteSeq" + selectedDay;
    const uniqueShipmentFields = Object.keys(this.coinTypes);

    uniqueShipmentFields.forEach(field => {
      let type = this.coinTypes[field].categoryName;
      if (typeof obj.coinShipmentObj[type] === "number" && obj.coinShipmentObj[type] > 0) {
        const shiptypeId = this.coinTypes[field].selected;
        const coinFlag = !!this.coinTypes[field].coinFlag;
        shipments.push({
          pickupDate: moment(obj.vaultDate).format(dtFormat),
          deliveryDate: moment(obj.vaultDate).format(dtFormat),
          vaultDate: moment(obj.vaultDate).format(dtFormat),
          fromLocationId: obj.fromLocation.Value,
          toLocationId: obj.toLocation.Value,
          routeSeq: obj.toLocation.dataObj[seqKey] || 0,
          routeId: obj.routeId.Value,
          batchId: obj.batchId,
          branchId: this.getSelectedBranches().toString(),
          coinFlag,
          trackingId: obj.trackingId + "-" + shiptypeId,
          amount: obj.coinShipmentObj[type] * this.getCoinValue(shiptypeId),
          qty: obj.coinShipmentObj[type],
          shiptypeId,
          pickupFlag: false,
          packedFlag: true,
        });
      }
    });

    if (typeof obj.cashAmount === "number" && obj.cashAmount >= 0) {
      shipments.push({
        pickupDate: moment(obj.vaultDate).format(dtFormat),
        deliveryDate: moment(obj.vaultDate).format(dtFormat),
        vaultDate: moment(obj.vaultDate).format(dtFormat),
        fromLocationId: obj.fromLocation.Value,
        toLocationId: obj.toLocation.Value,
        routeSeq: obj.toLocation.dataObj[seqKey] || 0,
        routeId: obj.routeId.Value,
        batchId: obj.batchId,
        branchId: this.getSelectedBranches().toString(),
        trackingId: obj.trackingId,
        amount: obj.cashAmount,
        qty: 1,
        shiptypeId: "C",
        pickupFlag: false,
        packedFlag: true,
      });
    }

    this.isCommitDisabled = true;
    return this.ShipmentService.createShipments(shipments, this.userDetails.id, this.branchHoldRoute)
      .then(() => {
        this._calendar.isSidePanelOpen = false;
        this.getAtmOrders();
      })
      .catch(err => {
        if (err && err.data && err.data.errors) {
          this.Modal.errorModal(err.data.errors[0].message);
        } else if (err && err.data && err.data.message) {
          this.Modal.errorModal(err.data.message);
        }
      })
      .finally(() => {
        this.isCommitDisabled = false;
      });
  }

  getDeliverToBankLocations(searchKey, offset) {
    searchKey = searchKey || "";
    const fromLocation = this.newCash.fromLocation;

    if (!fromLocation) {
      this.deliveryLocationObj.results = [];
      this.newCash.toLocation = null;
      return;
    }

    const branch = this.getSelectedBranches().toString();
    this.LocationService.getBankDeliverLocations(
      searchKey,
      branch,
      fromLocation.Value,
      offset,
      this.deliveryLocationObj.pagination.pageLimit,
      this.customerUser
    )
      .then(res => {
        if (offset === 0 || offset == undefined) {
          this.deliveryLocationObj.totalRecords = res.totalRecords;
          this.deliveryLocationObj.results = this.mappingData(res.locations, "name", "id");
        } else {
          const locations = this.mappingData(res.locations, "name", "id");
          this.deliveryLocationObj.results = this.deliveryLocationObj.results.concat(locations);
        }
      })
      .catch(err => {
        console.log(err);
        if (err && err.data && err.data.message) {
          this.Modal.errorModal(err.data.message);
        }
      });
  }

  getBranchCurrentVaultDate() {
    setTimeout(() => {
      const branch = this.getSelectedBranches().toString();
      this.branchDetails = _.find(this.filterDataSet.userBranches, { branchId: branch });
      this.filterDataSet.currentVaultDate = moment.utc(this.branchDetails.currentVaultDate).format("YYYY-MM-DD");
    });
  }

  isAllowToCreateCashDeliveries(selectedDate) {
    return moment(selectedDate).isSameOrAfter(this.filterDataSet.currentVaultDate);
  }

  tabViewSelection(pStat){
    if(this.$currentViewTab == pStat) return;
    this.$currentViewTab= pStat
    this.model.status = null;
    this.searchText = null;
    this.currentOrderStat = null;
    this.model.routeId = null;
    this.model.fundingSourceId = null;
    this.filter.locationId = null;
    if (!this.userDetails.customerUser) {
      this.filter.customerId = null;
    }
    this.filter.orderType = null;
    this.filter.selectedDenoms = [];
    this.setStartDate(this.formattedSelectedMonth);
    this.setEndDate(this.formattedSelectedMonth);
    this.filterDataSet.userBranches.forEach(branch => {
      branch.ticked = false;
      if (branch.branchId == this.branchId) {
        this.filterDataSet.currentVaultDate = moment.utc(branch.currentVaultDate).format("YYYY-MM-DD");
        branch.ticked = true;
      }
    });

    this.istevenMultiSelectLocalLang.nothingSelected = "Select Denomination"; 
    this.filterDataSet.denomsList.forEach(denom => {
      denom.ticked = false;
    });
    this._calendar.isEdit = false;
    this._calendar.isNew = false;
    this._calendar.monthIndex = 0;
    this.generateCalendarDays(this._calendar.monthIndex);
  }

  tabSelection(pStat, cStat) {
    this.newCash.batchId = "B1-" + moment().toDate().getTime();
    this.newCash.fromLocation = null;
    this.newCash.toLocation = null;
    this.newCash.routeId = null;
    this.newCash.cashAmount = 0;
    this.newCash.coinAmount = 0;
    this.newCash.totalAmount = 0;
    this.newCash.trackingId = null;
    this.newCash.coinShipmentObj = {};
    this.newCash.branchId = this.model.branch;
    this.newCash.orderNo = null;

    this.newCash.branchFundingSourceId = null;
    this.$currentTab = pStat;
    this.model.currentChildStat = null;
    if (this._calendar.selectedDateData) {
      this.createNewCashSchedule(this._calendar.selectedDateData, true);
    }
    if (pStat && cStat) this.model.currentStats = this.shipmentsCreateStats[pStat][cStat];

    this.filterOrderTypes()
    if (pStat === 'cashDeliveries' || pStat === 'ATMOrders' || pStat === 'atmLoad') {
      this.filterDataSet.locationList = [];
      this.filterDataSet.totalLocation = 0;
    }

    if(pStat==='cashDeliveries'){
      this.newCash.orderType = 'COD';
    } else {
      this.newCash.orderType = null;
    } 
  }

  childTabSelection(pStat, cStat) {
    this.model.currentChildStat = this.shipmentsCreateStats[pStat][cStat];
  }

  onLocationSelect(selectedLocation = "hel") {
   console.log("SELECTED, ", selectedLocation);
   
  }

  getLocationNextRoute() {
    if (!this.newCash.toLocation) return;

    this.model.isGettingLocationRoutes = true;

    if (this.newCash.fundingSource && this.newCash.fundingSource.Value) {
      this.getFundingSourceDenomination(this.newCash.fundingSource.Value);
    }

    this.$q.all([
      this.RouteService.getScheduledRouteByLocationId(this.getFormattedVaultDate(this.newCash.vaultDate), this.newCash.toLocation.Value, this.branchId),
      this.OrderViewService.findLocationRoute(this.newCash.toLocation.Value, this.getFormattedVaultDate(this.newCash.vaultDate))
    ])
      .then((res) => {
        const routes = this.mappingData(res[0].results, "name", "id");
        // this.filterDataSet.routeList = routes;
        // this.filterDataSet.totalRoutes = routes.length;

        const routeId = (res[0] && res[0].results && res[0].results.length) ? res[0].results[0].id : null;
        const findRoute = routeId ? _.find(this.filterDataSet.routeList, { Value: routeId }) : null;
        if (findRoute) this.newCash.routeId = findRoute;
        else this.newCash.routeId = null;
        if(this.newCash.toLocation && (this.newCash.fundingSource || this.newCash.fromLocation) && this.filterDataSet.routeList.length == 1){
          this.newCash.routeId = this.filterDataSet.routeList[0]
        }
        if (this.userDetails.customerUser && !this.newCash.routeId) {
          const holdRoute = _.find(this.filterDataSet.routeList, { Value: this.branchHoldRoute });
          const unassignedRoute = _.find(this.filterDataSet.routeList, { Value: this.branchUnassignedRoute });
          this.newCash.routeId = holdRoute || unassignedRoute || null;
        }
      })
      .catch(err => {
        if (err && err.data && err.data.message) {
          this.Modal.errorModal(err.data.message);
        }
      })
      .finally(() => {
        this.model.isGettingLocationRoutes = false;
      });
  }

  onEditVaultDateChange() {
    const locationId = this.newCash.locationId && this.newCash.locationId.Value;
    const requestedDate = this.getFormattedVaultDate(this.newCash.vaultDate);
    if (!locationId || !requestedDate) return;

    if (requestedDate === this.editRouteLookupDate) return;
    this.editRouteLookupDate = requestedDate;

    const saved = this.cloneShipmentObj || {};
    if (requestedDate === this.getFormattedVaultDate(saved.vaultDate)) {
      this.newCash.routeId = saved.routeId || null;
      return;
    }

    this.model.isGettingLocationRoutes = true;
    this.RouteService.getScheduledRouteByLocationId(requestedDate, locationId, this.branchId)
      .then((res) => {
        if (this.getFormattedVaultDate(this.newCash.vaultDate) !== requestedDate) return;

        const routeId = (res && res.results && res.results.length) ? res.results[0].id : null;
        let route = routeId ? _.find(this.filterDataSet.routeList, { Value: routeId }) : null;
        if (!route) {
          route = _.find(this.filterDataSet.routeList, { Value: this.branchHoldRoute })
            || _.find(this.filterDataSet.routeList, { Value: this.branchUnassignedRoute });
        }
        this.newCash.routeId = route ? route.Value : null;
      })
      .catch((err) => {
        if (err && err.data && err.data.message) {
          this.Modal.errorModal(err.data.message);
        }
      })
      .finally(() => {
        this.model.isGettingLocationRoutes = false;
      });
  }

  getFormattedVaultDate(date) {
    if (!date) return;
    return moment(date).format("YYYY-MM-DD");
  }

  createAtmOrders() {
    let totalAmount = 0,
      denominations = [],
      shipments = [];
    const branchId = this.getSelectedBranches().toString();

    this.newCash.isCreatingAtmOrders = true;
    this.newCash.atmDenominations.forEach(d => { // for atmLoad
      if (d.isEnabled && d.amount >= 0) {
        const billCount = this.shouldUseAmountInput(d) ? this.getBillCountFromAmount(d.amount, d.faceValue) : d.billCount;
        denominations.push({
          denominationId: d.icon,
          amount: d.amount,
          faceValue: d.faceValue,
          billCount,
          coinFlag: d.coinFlag || 0,
          multiDenomPackable: d.multiDenomPackable || false,
        });
        totalAmount += d.amount;
      }
    });

    if (this.model.currentStats === this.shipmentsCreateStats.cashDeliveries.all) {
      const uniqueShipmentFields = Object.keys(this.coinTypes);
      uniqueShipmentFields.forEach(field => {
        let type = this.coinTypes[field].categoryName;
        if (typeof this.newCash.coinShipmentObj[type] === "number" && this.newCash.coinShipmentObj[type] > 0) {
          const shiptypeId = this.coinTypes[field].selected;
          const coinFlag = !!this.coinTypes[field].coinFlag;
          shipments.push({
            coinFlag,
            shiptypeId,
            amount: this.newCash.coinShipmentObj[type] * this.getCoinValue(shiptypeId),
            qty: this.newCash.coinShipmentObj[type],
          });
        }
      });
    }

    const obj = {
      orderNo: this.newCash.orderNo,
      orderType: this.newCash.orderType,
      totalAmount: this.newCash.totalAmount,
      deliveryDate: moment(this.newCash.vaultDate).format("YYYY-MM-DD"),
      vaultDate: moment(this.newCash.vaultDate).format("YYYY-MM-DD"),
      branchFundingSourceId: this.newCash.fundingSource.Value,
      routeId: this.newCash.routeId ? (this.newCash.routeId.Value || this.newCash.routeId) : null,
      locationId: this.newCash.toLocation.Value,
      createdByUserId: this.userDetails.id,
      branchId,
      denominations,
      shipments,
      manualDeposit: this.newCash.fundingSource.dataObj["manualDeposit"],
      fromLocationId: this.newCash.fundingSource.dataObj["locationId"],
      sourceName: this.newCash.fundingSource.dataObj["sourceName"],
      account: this.newCash.account,
    };

    this.OrderViewService.createAtmOrders(obj)
      .then(res => {
        this._calendar.isSidePanelOpen = false;
        this.getAtmOrders();
      })
      .catch(err => {
        if (err && err.data && err.data.errors && err.data.errors.length) {
          if (err.data.errors[0].path == "SHIPMENT.shipment_tracking_id_unique") {
            this.Modal.errorModal("error.shipment_tracking_id_unique");
          }
        } else if (err && err.data && err.data.message) {
          this.Modal.errorModal(err.data.message);
        }
      })
      .finally(() => {
        this.newCash.isCreatingAtmOrders = false;
      });
  }

  // calculateDenominationAmount(type = 'denominations') {
  //   if (!this.newCash[type]) return;
  //   let totalAmount = this.newCash[type].reduce((sum, d) => {
  //     return d.isEnabled && d.amount !== undefined ? sum + d.amount : sum;
  //   }, 0);
  //   this.newCash.cashAmount = (this.newCash.cashAmount || 0) + totalAmount;
  //   this.getCurrencyTotal();
  // }

  calculateDenominationAmount() {
    let totalCashAmount = 0, totalCoinAmount = 0;
    if(this.$currentTab === 'cashDeliveries') {
    [...this.newCash.denominations, ...this.newCash.multiDenominations].forEach(d => {
      if (d.isEnabled && d.amount !== undefined && !d.coinFlag) totalCashAmount += d.amount;
      if (d.isEnabled && d.amount !== undefined && d.coinFlag) totalCoinAmount += d.amount;
    });
    } else {
    this.newCash.atmDenominations.forEach(d => {
      if (d.isEnabled && d.amount !== undefined && !d.coinFlag) totalCashAmount += d.amount;
      if (d.isEnabled && d.amount !== undefined && d.coinFlag) totalCoinAmount += d.amount;
    });
  }
    this.newCash.coinAmount = totalCoinAmount;
    this.newCash.cashAmount = totalCashAmount;
    this.newCash.totalAmount = this.newCash.cashAmount + this.newCash.coinAmount;
    this.getCurrencyTotal();
  }

  getSelectedFundingSourceData() {
    if (this.newCash && this.newCash.fundingSource && this.newCash.fundingSource.dataObj) {
      return this.newCash.fundingSource.dataObj;
    }

    const selectedFundingSourceId = this.newCash
      ? (this.newCash.fundingSourceId || (this.newCash.fundingSource && this.newCash.fundingSource.Value))
      : null;

    if (!selectedFundingSourceId || !Array.isArray(this.filterDataSet.branchFundingSource)) {
      return null;
    }

    const selectedFundingSource = this.filterDataSet.branchFundingSource.find(
      bfs => String(bfs.Value) === String(selectedFundingSourceId)
    );

    return selectedFundingSource ? selectedFundingSource.dataObj : null;
  }

  shouldUseAmountInput(denomination) {
    const fundingSource = this.getSelectedFundingSourceData();
    return !!(fundingSource && fundingSource.allowAmount && denomination);
  }

  getBillCountFromAmount(amount, faceValue) {
    const parsedAmount = Number(amount);
    const parsedFaceValue = Number(faceValue);

    if (!Number.isFinite(parsedAmount) || !Number.isFinite(parsedFaceValue) || parsedFaceValue <= 0) {
      return null;
    }

    const billCount = parsedAmount / parsedFaceValue;
    const roundedBillCount = Math.round(billCount);

    return Math.abs(billCount - roundedBillCount) < 0.000001 ? roundedBillCount : billCount;
  }

  handleDenominationInputChange(denominationIndex, type) {
    this.newCash.isInteracted = true;
    const denomination = this.newCash[type] && this.newCash[type][denominationIndex];
    if (!denomination) return;

    if (this.shouldUseAmountInput(denomination)) {
      this.checkAmountFromAmount(denominationIndex, denomination.amount, denomination.faceValue, type);
      return;
    }

    this.checkAmount(denominationIndex, denomination.billCount, denomination.faceValue, type);
  }

  checkAmountFromAmount(denominationIndex, amount, faceValue, type) {
    const orderTypes = ["P", "T"];
    const normalizedAmount = amount >= 0 ? Number(amount) : null;
    const billCount = this.getBillCountFromAmount(normalizedAmount, faceValue);
    const isDivisible = Math.abs(billCount - Math.round(billCount)) < 0.000001;

    if (this.newCash[type][denominationIndex].isEnabled) {
      if (orderTypes.includes(this.newCash.orderType)) {
        // Decash: allow 0, but NOT null/empty. Check divisibility if non-zero.
        this.newCash[type][denominationIndex].isValid = (normalizedAmount === 0 || (normalizedAmount !== null && isDivisible));
      } else {
        // Regular: must be > 0 and divisible
        this.newCash[type][denominationIndex].isValid = (normalizedAmount !== null && normalizedAmount > 0 && isDivisible);
      }
    }

    this.validateBillCount();

    this.newCash[type][denominationIndex].amount = normalizedAmount;
    this.newCash[type][denominationIndex].billCount = normalizedAmount !== null
      ? this.getBillCountFromAmount(normalizedAmount, faceValue)
      : null;
  }

  checkAmount(denominationIndex, billCount, faceValue, type) {//= 'denominations'
    const orderTypes = ["P", "T"];
    let amount = 0;
    amount = billCount >= 0 ? billCount * faceValue : null;
    let amountInCents = amount ? Math.round(amount * 100) : 0;
    if (this.newCash[type][denominationIndex].isEnabled) {
      if (orderTypes.includes(this.newCash.orderType)) {
        // Decash: allow 0, but NOT null/empty
        this.newCash[type][denominationIndex].isValid = (billCount !== null);
      } else {
        // Regular: must be > 0
        this.newCash[type][denominationIndex].isValid = (billCount !== 0 && billCount !== null);
      }
    }

    this.validateBillCount();
    this.newCash[type][denominationIndex].amount = amount;
  }

  validateATMOrderCreateBtn() {
    const orderTypes = ["P", "T"];
    let cursor = 0,
      isValidDay = false,
      isValidMonth = false;

    Object.keys(this.newCash.recurringDays).filter(key => {
      if (this.newCash.recurringDays[key]) isValidDay = true;
    });

    // Object.keys(this.newCash.recurringMonths).filter((key) => {
    //     if (this.newCash.recurringMonths[key]) isValidMonth = true;
    // });

    var disableButton = this.newCash.atmDenominations.map(denom => { // for atmLoad
      if (denom.isEnabled)
        return (
          ((orderTypes.includes(this.newCash.orderType) ? denom.amount >= 0 : denom.amount > 0) &&
            denom.isValid !== undefined &&
            denom.isValid &&
            // (this.model.currentChildStat === this.shipmentsCreateStats.ATMOrders.recurring && this.newCash.selectedPattern === 'monthly' ? isValidMonth : true) &&
            (this.model.currentChildStat === this.shipmentsCreateStats.ATMOrders.recurring
              ? this.newCash.recurringStartDate &&
                (this.newCash.recurringEndDate || this.newCash.endRecurringAfter) &&
                this.newCash.selectedPattern === "weekly"
                ? isValidDay
                : true
              : true)) ||
          "isEmpty"
        );
    });

    disableButton.forEach(d => {
      if (d == undefined) cursor++;
      else cursor = 0;
    });
    if (
      this.model.currentStats === this.shipmentsCreateStats.cashDeliveries.all ||
      this.model.currentStats === this.shipmentsCreateStats.ATMOrders.all
    ) {
      if (this.newCash.coinAmount > 0 || this.newCash.cashAmount > 0) return false;
    }
    return disableButton.indexOf("isEmpty") !== -1 || this.newCash.atmDenominations.length === cursor;
  }

  validateBillCount() {
    const orderTypes = ["P", "T"];
    let isAllValid = true;
    let isMultipleInvalid = false;
    let isZeroInvalid = false;
    const fundingSource = this.getSelectedFundingSourceData();
    const allowAmount = !!(fundingSource && fundingSource.allowAmount);

    let denomsToValidate = [];
    const isPackable = (this.newCash.isPackableOrder !== undefined && this.newCash.isPackableOrder !== null)
      ? !!this.newCash.isPackableOrder
      : (this.$currentTab === 'cashDeliveries' || 
         this.model.currentStats === this.shipmentsCreateStats.cashDeliveries.all ||
         this.model.currentStats === this.shipmentsCreateStats.prePacked.all);

    if (isPackable) {
      denomsToValidate = [...(this.newCash.denominations || []), ...(this.newCash.multiDenominations || [])];
    } else {
      denomsToValidate = this.newCash.atmDenominations || [];
    }

    denomsToValidate.forEach(denom => {
      if (denom.isEnabled) {
        const isDecash = orderTypes.includes(this.newCash.orderType);
        if (isDecash && !this._calendar.isEdit) {
          denom.amount = 0;
          denom.billCount = 0;
        }
        if (allowAmount) {
          // Amount Mode Logic
          const amount = (denom.amount !== null && denom.amount !== undefined) ? Number(denom.amount) : null;
          const faceValue = Number(denom.faceValue || 0);
          const calculatedBillCount = this.getBillCountFromAmount(amount, faceValue);
          const isDivisible = Math.abs(calculatedBillCount - Math.round(calculatedBillCount)) < 0.000001;

          if (amount !== null && !isDivisible) {
            denom.isValid = false;
            isAllValid = false;
            isMultipleInvalid = true;
          } else if (amount === 0 || (amount > 0 && Math.round(calculatedBillCount) === 0)) {
            denom.isValid = isDecash;
            if (!isDecash) {
              isAllValid = false;
              if (this.newCash.isInteracted) {
                isZeroInvalid = true;
              }
            }
          } else if (amount === null || amount === undefined) {
            denom.isValid = false; // Empty field is always invalid
            isAllValid = false;
          } else {
            denom.isValid = true;
          }
        } else {
          // Quantity Mode Logic
          const billCount = (denom.billCount !== null && denom.billCount !== undefined) ? Number(denom.billCount) : null;
          if (billCount === 0) {
            denom.isValid = isDecash;
            if (!isDecash) {
              isAllValid = false;
              if (this.newCash.isInteracted) {
                isZeroInvalid = true;
              }
            }
          } else if (billCount === null || billCount === undefined) {
            denom.isValid = false; // Empty field is always invalid
            isAllValid = false;
          } else {
            denom.isValid = true;
          }
        }
      }
    });
    this.isValidBillCount = isAllValid;
    this.isMultipleInvalid = isMultipleInvalid;
    this.isZeroInvalid = isZeroInvalid;
    if (orderTypes.includes(this.newCash.orderType)) this.calculateDenominationAmount();
  }
    updateScheduledShipment() {
      this.isUpdatingAtmOrders = true;
      let amount = 0;
      let denominations = [];
      const locationId = this.newCash.locationId.Value || null;
      const locationScheduleRecurringId = this.newCash.locationScheduleRecurringId || null;
      this.newCash.isUpdatingAtmOrders = true;
      if(this.newCash.isPackableOrder) {
        denominations = [
          ...this.newCash.denominations,
          ...this.newCash.multiDenominations
        ].filter(denom => denom.isEnabled);
      } else {
        denominations = this.newCash.atmDenominations.filter(denom => denom.isEnabled);
      }
      if (this.updatedCash.coinShipmentAmount) {
        amount = this.updatedCash.coinShipmentAmount
    } else {
        amount = this.newCash.cashShipmentAmount;
    }

    if(this.newCash.fetchedDenominations){
    this.newCash.fetchedDenominations.forEach(denomination => {
      const found = denominations.find(d => d.icon === denomination.icon);
      if (!found) {
        denominations.push({
          ...denomination,
          isDeleted: true
        });
      }
    });
  }

  this.OrderViewService.updateScheduledShipment(denominations, locationId, locationScheduleRecurringId)
      .then(() => {
        this.getAtmOrders();
      })
      .catch(err => {
        if (err && err.data && err.data.message) {
          this.Modal.errorModal(err.data.message);
        }
      })
      .finally(() => {
        this.newCash.isUpdatingAtmOrders = false;
        this._calendar.isSidePanelOpen = false;
        this._calendar.isEdit = false;
      });
    }

    updatePendingPackShipment() {
        const orderNo = this.newCash.orderNo;
        const locationId = this.newCash.locationId.Value || null;
        const orderType = this.newCash.orderType;
        const vaultDate = moment(this.newCash.vaultDate).format('YYYY-MM-DD');
        const routeId = this.newCash.routeId;
        const branch = this.getSelectedBranches().toString();
        const cashOrderId = this.newCash.cashOrderId;
        const trackingId = this.newCash.trackingIdDelivery;
        let amount = 0;
        let denominations = [];
        if(this.newCash.isPackableOrder) {
          denominations = [
            ...this.newCash.denominations,
            ...this.newCash.multiDenominations
          ].filter(denom => denom.isEnabled);
        } else {
          denominations = this.newCash.atmDenominations.filter(denom => denom.isEnabled);
        }
        if (this.updatedCash.coinShipmentAmount) {
          amount = this.updatedCash.coinShipmentAmount
      } else {
          amount = this.newCash.cashShipmentAmount;
      }
      const denominationId = this.newCash.denominationId;
      this.newCash.isUpdatingAtmOrders = true;

      if(this.newCash.fetchedDenominations){
      this.newCash.fetchedDenominations.forEach(denomination => {
        const found = denominations.find(d => d.icon === denomination.icon);
        if (!found) {
          denominations.push({
            ...denomination,
            isDeleted: true
          });
        }
      });
    }
      const updateServiceCall = this.newCash.isPackableOrder ? this.OrderViewService.updatePendingPackOrder : this.OrderViewService.updatePendingPackShipment;
      updateServiceCall.call(this.OrderViewService, 
      denominations, vaultDate, locationId, routeId, orderNo, orderType, amount, branch, denominationId,this.userDetails.id)
      .then(() => {
          this.getAtmOrders();
      })
      .catch(err => {
        if (err && err.data && err.data.message) {
          this.Modal.errorModal(err.data.message);
        }
      })
      .finally(() => {
        this.newCash.isUpdatingAtmOrders = false;
        this._calendar.isSidePanelOpen = false;
        this._calendar.isEdit = false;
      });
  }

  cancelAtmOrder(shipment) {
    this.newCash.deleteAtmOrders = true;
    shipment.trackingId = shipment.trackingIdDelivery;

    const performDelete = (modal, supId) => {
      const deleteMethod = shipment.isPackableOrder
        ? this.OrderPackingService.softDeleteOrder(shipment.orderNo, supId, this.branchId)
        : this.ShipmentService.softDeleteWholeShipment(shipment.orderNo, this.branchId, supId);
      
      deleteMethod
        .then(() => {
          modal.close();
          this._calendar.isEdit = false;
          this._calendar.isNew = false;
          setTimeout(() => {
            this.getAtmOrders();
          }, 500);
        })
        .catch(err => {
          modal.close();
          if (err && err.data && err.data.message) {
            this.Modal.errorModal("error." + err.data.message);
          }
        })
        .finally(() => {
          this.newCash.deleteAtmOrders = false;
        });      
    };
    
    if (this.userDetails.customerUser) {
      this.Modal.confirm({
        header: 'Confirm Delete',
        message: 'Are you sure you want to delete this shipment?',
        type: 'danger',
        callback: ({ modal }) => performDelete(modal, null),
        negative: ({ modal }) => {
          this.newCash.deleteAtmOrders = false;
          modal.close();
        }
      });
    } else {
      this.Modal.confirmSupervisor(
        'order-delete', null,
        ({ modal, supId }) => performDelete(modal, supId),
        ({ modal }) => {
          this.newCash.deleteAtmOrders = false;
          modal.close();
        }
      );
    }
  }

  // cancelAtmOrder() {
  //     const branch = this.getSelectedBranches().toString();
  //     this.Modal.confirmSupervisor('cancel-atm-order', null, ({ modal, supId }) => {
  //         this.newCash.deleteAtmOrders = true;

  //         this.OrderViewService.cancelAtmOrder(this.newCash.cashOrderId, branch, supId)
  //             .then(() => {
  //                 setTimeout(() => {
  //                     this.getAtmOrders();
  //                 }, 500)
  //             })
  //             .catch((err) => {
  //                 if (err && err.data && err.data.message) {
  //                     this.Modal.errorModal(err.data.message);
  //                 }
  //             })
  //             .finally(() => {
  //                 this.newCash.deleteAtmOrders = false;
  //                 this._calendar.isSidePanelOpen = false;
  //                 this._calendar.isEdit = false;
  //                 modal.close();
  //             })
  //     }, ({ modal }) => {
  //         modal.close();
  //     });
  // }

  // scheduledTabSelection() {
  //     if (this.model.currentStats === this.stats.pending) this.model.isCompleted = 0;
  //     else if (this.model.currentStats === this.stats.completed) this.model.isCompleted = 1;
  //     this.loadData();
  // }

  // createScheduledAtmShipment() {
  //     this.Modal.scheduledATMShipment(({ modal }) => {
  //     }, ({ modal }) => {
  //         modal.close();
  //     })
  // }

  toggleDay(day) {
    this.newCash.recurringDays[day.value] = !this.newCash.recurringDays[day.value];
  }

  selectedPattern(pattern) {
    this.newCash.selectedPattern = pattern.value;
  }

  isDaySelected(day) {
    return this.newCash.recurringDays[day.value];
  }

  validateRecurringStartDate() {
    this.newCash.currentStats = this.model.currentStats;
    this.minRecurrStartDate = {
      // minDate: this.model.currentStats === this.shipmentsCreateStats.stops.multiple ? moment():  this.newCash.vaultDate,
      // moment().isSameOrAfter(this._calendar.selectedDateData.date) ? moment() : this._calendar.selectedDateData.date
      minDate: moment(),
      maxDate: moment(this.newCash.recurringStartDate).add(1, "years"),
    };
    this.newCash.recurringStartDate = this.minRecurrStartDate.minDate;
  }

  validateEndDate() {
    this.minRecurrDate = {
      minDate: this.newCash.recurringStartDate,
      maxDate: moment(this.newCash.recurringStartDate).add(1, "years"),
    };

    if (this.newCash.recurringEndDate && moment(this.newCash.recurringStartDate).isAfter(this.newCash.recurringEndDate)) {
      this.newCash.recurringEndDate = this.newCash.recurringStartDate;
    }
  }

  confirmRecurring(currentStats) {
    this.Modal.confirm({
      header: this.$translate.instant("common.confirm_title"),
      message: this.$translate.instant("master_cash_schedule.confirm_recurring"),
      callback: ({ modal }) => {
        this.isCommit = false;
        modal.close();
        this.createRecurring(modal, currentStats);
      },
      negative: ({ modal }) => {
        modal.close();
        this.isCommit = false;
      },
      buttons: ["common.ok", "common.cancel"],
      type: "success",
    });
  }

  createRecurring(modal, currentStats) {
    let totalAmount = 0,
      denominations = [],
      shipments = [];
    const branchId = this.getSelectedBranches().toString();
    const dayOfMonthObj = {
      january: 0,
      february: 1,
      march: 2,
      april: 3,
      may: 4,
      june: 5,
      july: 6,
      august: 7,
      september: 8,
      october: 9,
      november: 10,
      december: 11,
    };

    if(this.$currentTab === "cashDeliveries") {
    this.newCash.denominations.forEach(d => {
      if (d.isEnabled && d.amount > 0) {
        const billCount = this.shouldUseAmountInput(d) ? this.getBillCountFromAmount(d.amount, d.faceValue) : d.billCount;
        denominations.push({
          denominationId: d.icon,
          amount: d.amount,
          faceValue: d.faceValue,
          billCount,
          multiDenomPackable: d.multiDenomPackable,
          coinFlag: d.coinFlag,
          shiptypeId: d.shiptypeId,
        });
        totalAmount += d.amount;
      }
    });

    this.newCash.multiDenominations.forEach(d => {
      if (d.isEnabled && d.amount > 0) {
        const billCount = this.shouldUseAmountInput(d) ? this.getBillCountFromAmount(d.amount, d.faceValue) : d.billCount;
        denominations.push({
          denominationId: d.icon,
          amount: d.amount,
          faceValue: d.faceValue,
          billCount,
          multiDenomPackable: d.multiDenomPackable,
          coinFlag: d.coinFlag,
        });
        totalAmount += d.amount;
      }
    });
    } else {

    this.newCash.atmDenominations.forEach(d => { // for atmLoad
      if (d.isEnabled && d.amount > 0) {
        const billCount = this.shouldUseAmountInput(d) ? this.getBillCountFromAmount(d.amount, d.faceValue) : d.billCount;
        denominations.push({
          denominationId: d.icon,
          amount: d.amount,
          faceValue: d.faceValue,
          billCount,
          multiDenomPackable: d.multiDenomPackable,
          coinFlag: d.coinFlag,
        });
        totalAmount += d.amount;
      }
    });
    }

    if (currentStats === this.shipmentsCreateStats.cashDeliveries.all) {
      const uniqueShipmentFields = Object.keys(this.coinTypes);
      uniqueShipmentFields.forEach(field => {
        let type = this.coinTypes[field].categoryName;
        if (typeof this.newCash.coinShipmentObj[type] === "number" && this.newCash.coinShipmentObj[type] > 0) {
          const shiptypeId = this.coinTypes[field].selected;
          const coinFlag = !!this.coinTypes[field].coinFlag;
          shipments.push({
            coinFlag,
            shiptypeId,
            amount: this.newCash.coinShipmentObj[type] * this.getCoinValue(shiptypeId),
            qty: this.newCash.coinShipmentObj[type],
          });
        }
      });
    }

    const obj = {
      orderNo: this.newCash.orderNo,
      orderType: this.newCash.orderType,
      totalAmount: this.newCash.totalAmount,
      vaultDate: moment(this.newCash.vaultDate).format("YYYY-MM-DD"),
      fundingSourceId: this.newCash.fundingSource.Value,
      routeId: this.newCash.routeId.Value,
      locationId: this.newCash.toLocation.Value,
      createdByUserId: this.userDetails.id,
      branchId,
      denominations,
      shipments,
      manualDeposit: this.newCash.fundingSource.dataObj["manualDeposit"],
      fromLocationId: this.newCash.fundingSource.dataObj["locationId"],
      fundingSourceName: this.newCash.fundingSource.dataObj["sourceName"],
      recurringStartDate: moment(this.newCash.recurringStartDate).format("YYYY-MM-DD 00:00:00"),
      recurringEndDate: this.newCash.recurringEndDate ? moment(this.newCash.recurringEndDate).format("YYYY-MM-DD 23:59:59") : null,
      selectedPattern: this.newCash.selectedPattern,
      recurWeeks: this.newCash.recurWeeks,
      recurringDays: Object.keys(this.newCash.recurringDays).filter(key => {
        return this.newCash.recurringDays[key];
      }),
      toLocationName: this.newCash.toLocation.dataObj.name,
      routeName: this.newCash.routeId.dataObj.name,
      customerId: this.newCash.toLocation.dataObj.customerId,
      recurringFrequency: this.recurringFrequency(this.newCash.selectedPattern, this.newCash.recurWeeks, this.newCash.recurringMonthObj),
      scheduleMonths: Object.keys(this.newCash.recurringMonths).filter(key => {
        return this.newCash.recurringMonths[key];
      }),
      recurringDayInterval: this.newCash.recurringDayInterval,
      selectedMonthlyPattern: this.selectedMonthlyPattern,
      endRecurringAfter: this.newCash.endRecurringAfter,
    };

    if (this.selectedMonthlyPattern === "the") {
      this.monthlyRecurring = {
        weekInterval: this.newCash.recurringMonthObj.month.weekInterval,
        selectedWeekDay: this.newCash.recurringMonthObj.month.selectedWeekDay,
        monthInterval: this.newCash.recurringMonthObj.month.monthInterval,
        frequencyMonth: this.newCash.recurringMonthObj.month.frequencyMonth,
        frequencyWeek: this.newCash.recurringMonthObj.month.frequencyWeek,
      };
    }

    const weekDays = obj.recurringDays.map(rd => rd.charAt(0).toUpperCase() + rd.slice(1));
    obj.scheduleWeekDays = weekDays.splice(",").join(" | ");
    obj.scheduleMonths = obj.scheduleMonths.map(d => dayOfMonthObj[d]);
    obj.recurringMonthObj = this.selectedMonthlyPattern === "day" ? this.newCash.recurringMonthObj.day : this.monthlyRecurring;
    obj.isPackableOrder = this.$currentTab === "cashDeliveries" ? 1 : 0;
    this.newCash.isCreateRecurring = true;
    this.OrderViewService.createRecurringATMLoadShipment(obj)
      .then(res => {
        this.getAtmOrders();
      })
      .catch(err => {
        console.log(err);
      })
      .finally(() => {
        if (modal) modal.close();
        this.newCash.isCreateRecurring = false;
      });
  }

  generateOrderNumber() {
    this.model.gettingOrderNo = true;
    this.OrderViewService.generateOrderNumber()
      .then(res => {
        this.newCash.orderNo = res.nextOrderNumber;
      })
      .catch(err => {
        console.log(err);
      })
      .finally(() => {
        this.model.gettingOrderNo = false;
      });
  }

  getLocationOrdersSinceSwap() {
    if (!this.newCash.toLocation) return;

    this.model.gettingLocOrder = true;
    this.OrderViewService.getLocationOrdersSinceSwap(this.newCash.toLocation.Value)
      .then(res => {
        this.nextOrderType = res.nextOrderType;
        this.newCash.orderType = this.nextOrderType;
      })
      .catch(err => {
        console.log(err);
      })
      .finally(() => {
        this.model.gettingLocOrder = false;
      });
  }

  setOrderType() {
    if (this.model.currentChildStat === this.shipmentsCreateStats.ATMOrders.recurring && this.newCash.toLocation) {
      this.getLocationOrdersSinceSwap();
    }
  }

  recurringFrequency(selectedPattern = null, recurWeeks = 0, recurringMonthObj) {
    const weeks = { 1: "Every 1st Week", 2: "Every 2nd Week", 3: "Every 3rd Week", 4: "Every 4th Week" };
    const dayOfWeekObj = { 0: "sunday", 1: "monday", 2: "tuesday", 3: "wednesday", 4: "thursday", 5: "friday", 6: "saturday" };

    switch (selectedPattern) {
      case "daily": {
        return "Daily";
      }
      case "weekly": {
        return weeks[recurWeeks];
      }
      case "monthly": {
        if (this.selectedMonthlyPattern === "day") {
          recurringMonthObj.day.frequencyMonth = `${this.CommonLayoutService.ordinalSuffixOf(recurringMonthObj.day.monthInterval)} Month`;
          recurringMonthObj.day.frequencyDay = recurringMonthObj.day.dayInterval;
          return `Monthly`;
        } else if (this.selectedMonthlyPattern === "the") {
          recurringMonthObj.month.frequencyMonth = `${this.CommonLayoutService.ordinalSuffixOf(recurringMonthObj.month.monthInterval)} Month`;
          recurringMonthObj.month.frequencyWeek = `${weeks[recurringMonthObj.month.weekInterval]} (${dayOfWeekObj[recurringMonthObj.month.selectedWeekDay]})`;
          return `Monthly`;
        }
      }
      default:
        return;
    }
  }

  cancelRecurringATMLoadShipment(obj) {
    this.newCash.deleteAtmOrders = true;
    let denominationId= null;
    if(obj.isPackableOrder){
      if (obj.coinShipments.length >0 ){
      denominationId = obj.coinShipments[0].denominations[0].denominationId;
      }
      else 
      {
        denominationId = obj.denominationId;
      }
    } else {
      denominationId = null; //As in case of ATM Load Shipment, denominationId is not required we delete the whole job
    }
    this.OrderViewService.cancelRecurringATMLoadShipment(obj.jobId, null)
      .then(res => {
        this._calendar.isSidePanelOpen = false;
        this._calendar.isNew = false;
        this._calendar.isEdit = false;
        this.getAtmOrders();
      })
      .catch(err => {
        console.log(err);
      })
      .finally(() => {
        this.newCash.deleteAtmOrders = false;
      });
  }

  allowRecurring() {
    return moment(moment().format("YYYY-MM-DD")).isSameOrBefore(this._calendar.selectedDateData.formatedDate);
  }

  toggleMonth(month) {
    this.newCash.recurringMonths[month.value] = !this.newCash.recurringMonths[month.value];
  }

  isMonthSelected(month) {
    return this.newCash.recurringMonths[month.value];
  }

  resetRecurringData() {
    Object.keys(this.newCash.recurringMonths).filter(key => {
      return (this.newCash.recurringMonths[key] = false);
    });
    this.newCash.recurWeeks = 0;
  }

  getMonthlyPattern(pattern) {
    this.selectedMonthlyPattern = pattern;
  }

  resetMothlyPattern() {
    if (this.selectedMonthlyPattern === "day") {
      this.newCash.recurringMonthObj.month.weekInterval = null;
      this.newCash.recurringMonthObj.month.selectedWeekDay = null;
      this.newCash.recurringMonthObj.month.monthInterval = null;
    } else if (this.selectedMonthlyPattern === "the") {
      this.newCash.recurringMonthObj.day = {
        dayInterval: null,
        monthInterval: null,
      };
    }
  }

  updatePackedCashBag() {
    const vaultDate = moment(this.newCash.vaultDate).format("YYYY-MM-DD");
    const routeId = this.newCash.routeId;
    const branch = this.getSelectedBranches().toString();
    const trackingId = this.newCash.trackingIdDelivery;
    const coinShipments = this.updatedCash.coinShipments;
    const cashShipmentAmount = this.updatedCash.cashShipmentAmount;
    this.newCash.isUpdatingPackedCashBag = true;
    this.OrderViewService.updatePackedCashBag(trackingId, vaultDate, routeId, branch, coinShipments, cashShipmentAmount)
      .then(() => {
        setTimeout(() => {
          this.getAtmOrders();
        }, 500);
      })
      .catch(err => {
        if (err && err.data && err.data.message) {
          this.Modal.errorModal(err.data.message);
        }
      })
      .finally(() => {
        this.newCash.isUpdatingPackedCashBag = false;
        this._calendar.isSidePanelOpen = false;
        this._calendar.isEdit = false;
      });
  }

  getRouteListFromSelectedLocation() {
    let locationId;
    if (this.model.currentStats === this.shipmentsCreateStats.prePacked.all && this.newCash.fromLocation) {
      locationId = this.newCash.fromLocation.Value;
    } else if (this.newCash.fundingSource) {
      locationId = this.newCash.fundingSource.dataObj["locationId"];
    }
    const vaultDate = moment(this.newCash.vaultDate).format("YYYY-MM-DD");

    if (!locationId || !vaultDate) {
      this.newCash.routeId = "";
      this.getActiveRoutes(0, "");
      return;
    };
    this.RouteService.getScheduledRouteByLocationId(vaultDate, locationId, this.branchId).then(res => {
      const routes = this.mappingData(res.results, "name", "id");
      // this.filterDataSet.routeList = routes;
      // this.filterDataSet.totalRoutes = routes.length;
      // this.newCash.routeId = "";
      
      const routeId = res.results && res.results.length > 0 ? res.results[0].id : null;
      const findRoute = _.find(routes, { Value: routeId });
      if (findRoute) this.newCash.routeId = findRoute;
      else this.newCash.routeId = null;
    });
  }

  updateTotalUpdateAmount(coinShipment) {
    if (!coinShipment.qty) return; 
    let amount = 0;
    this.updatedCash.coinShipmentAmount -= coinShipment.amount;
    if(this.newCash.isPackableOrder) {
       amount = Number(coinShipment.qty) * coinShipment.denomFaceValue;
    }
    else{
    amount = Number(coinShipment.qty) * this.getCoinValue(coinShipment.shiptypeId);
    }
    coinShipment.amount = amount;
    this.updatedCash.coinShipmentAmount += amount;
}

  checkForStrapCount(type = null) {
    if (!this.newCash.fundingSource) return true;

    let isValid = true;
    if (this.newCash.fundingSource.dataObj) {
      const strapCountEnforced = this.newCash.fundingSource.dataObj.enforceStraps || false;
      if (strapCountEnforced) {
        let denomsToValidate = [];
        if (type) {
          denomsToValidate = this.newCash[type] || [];
        } else {
          const isPackable = (this.newCash.isPackableOrder !== undefined && this.newCash.isPackableOrder !== null)
            ? !!this.newCash.isPackableOrder
            : (this.$currentTab === 'cashDeliveries' || 
               this.model.currentStats === this.shipmentsCreateStats.cashDeliveries.all ||
               this.model.currentStats === this.shipmentsCreateStats.prePacked.all);
          
          if (isPackable) {
            denomsToValidate = [...(this.newCash.multiDenominations || []), ...(this.newCash.denominations || [])];
          } else {
            denomsToValidate = this.newCash.atmDenominations || [];
          }
        }

        for (let i = 0; i < denomsToValidate.length; ++i) {
          const item = denomsToValidate[i];
          if (item.strapCount && item.billCount && item.isEnabled) {
            if (item.billCount % item.strapCount !== 0) {
              isValid = false;
              break;
            }
          }
        }
      }
    }
    this.isValidStrapBillCount = isValid;
    return isValid;
  }

  // scheduleLocation(modal) {
  //     const branchId = this.getSelectedBranches().toString();

  //     const obj = {
  //         vaultDate: moment(this.newCash.vaultDate).format('YYYY-MM-DD'),
  //         routeId: this.newCash.routeId.Value,
  //         locationId: this.newCash.toLocation.Value,
  //         createdByUserId: `${this.userDetails.id}`,
  //         createdByUserName: `${this.userDetails.firstName} ${this.userDetails.lastName}`,
  //         branchId,
  //         recurringStartDate: moment(this.newCash.recurringStartDate).format('YYYY-MM-DD 00:00:00'),
  //         recurringEndDate: moment(this.newCash.recurringEndDate).format('YYYY-MM-DD 23:59:59'),
  //         selectedPattern: this.newCash.selectedPattern,
  //         recurWeeks: this.newCash.recurWeeks,
  //         locationName: this.newCash.toLocation.dataObj.name,
  //         routeName: this.newCash.routeId.dataObj.name,
  //         customerId: this.newCash.toLocation.dataObj.customerId,
  //         routeSequence: this.newCash.routeSequence || null,
  //         locationType: this.newCash.toLocation.dataObj.locationType,
  //         recurringDays: Object.keys(this.newCash.recurringDays).filter((key) => {
  //             return this.newCash.recurringDays[key]
  //         })
  //     };

  //     console.log(obj)
  //     this.newCash.isCreateRecurring = true;
  //     this.OrderViewService.createLocationRecurring(obj)
  //         .then(() => {
  //             this.getAtmOrders();
  //         })
  //         .catch(err => {
  //             console.log(err);
  //         })
  //         .finally(() => {
  //             if (modal) modal.close();
  //             this.newCash.isCreateRecurring = false;
  //         })
  // }

  // confirmLocationRecurring() {
  //     this.Modal.confirm({
  //         header: this.$translate.instant('common.confirm_title'),
  //         message: this.$translate.instant('master_cash_schedule.confirm_stops_recurring'),
  //         callback: (({
  //             modal
  //         }) => {
  //             this.isCommit = false;
  //             modal.close();
  //             this.scheduleLocation(modal)
  //         }),
  //         negative: (({
  //             modal,
  //         }) => {
  //             modal.close();
  //             this.isCommit = false;
  //         }),
  //         buttons: ['common.ok', 'common.cancel'],
  //         type: 'success'
  //     })
  // }

  // validateStopsScheduleBtn() {
  //     const disableButton = this.newCash.recurringStartDate && this.newCash.recurringEndDate &&
  //         this.newCash.toLocation && this.newCash.toLocation.Value && this.newCash.routeId &&
  //         this.newCash.routeId.Value || 'isEmpty';
  //     return disableButton.indexOf('isEmpty') !== -1;
  // }

  handleEditCash(dateCollection) {
    if (dateCollection.isPackableOrder){
      this.allOrderTypes = [...this.filterDataSet.orderTypes].filter(o => o.key == "Change Order Delivery");
    } else{
      this.allOrderTypes = [...this.filterDataSet.orderTypes]
        .filter(o => o.key !== "Change Order Delivery" && o.value !== 'T&R');
    }
    this.$q.all([
      this.getAllFundingSource("", 0),
      this.getFundingSourceDenomination(dateCollection.fundingSourceId, dateCollection)
    ])
      .then(() => {
        this.editCashSchedule(dateCollection);
        if(dateCollection.isPackableOrder){
          this.checkForStrapCount('denominations');
          this.checkForStrapCount('multiDenominations');
        } else {
          this.checkForStrapCount('atmDenominations');
        }
      })
      .catch(error => {
        console.error("Error in getFundingSourceDenomination:", error);
      });
  };

  redirectToOrderTab(data) {
    let isInProcess = data.packedFlag && !data.finishedAt;
    let isPending = !data.packedFlag;
    let isCounted = data.finishedAt;
    let fundingSourceId = data.fundingSourceId ? data.fundingSourceId : (this.model.locationId && this.model.locationId.Value);
    this.Navigation.goToOrderHistory(data.orderNo, data.vaultDate, true, isCounted, isInProcess, isPending, null, fundingSourceId);
}

  getFundingSourceDenomination(branchFundingSourceId, dateCollection = null) {
    if (!branchFundingSourceId) return;
    this.loadBfsDenomination = true;
    this.denominationAllType = [];
    this.newCash.denominations = [];
    this.newCash.multiDenominations = [];
    this.newCash.remainingDenominations = [];
    this.newCash.remainingMultiDenominations = [];
    this.newCash.remainingAtmDenominations = [];
    this.newCash.atmDenominations = [];
    let fetchDenominations= []

    const selectedBFS = this.filterDataSet.branchFundingSource.find(bfs => bfs.Value === branchFundingSourceId);
    const currencyId = selectedBFS ? selectedBFS.dataObj.currencyId : null;    
    const locationId = (dateCollection && dateCollection.toLocationId) ? dateCollection.toLocationId : (this.newCash.toLocation ? this.newCash.toLocation.Value : null);
    if(dateCollection){
       fetchDenominations = dateCollection.isPackableOrder === 1
        ? this.OrderViewService.getFundingSourceDenominationUnpack(branchFundingSourceId)
        : this.OrderViewService.getFundingSourceDenomination(branchFundingSourceId, locationId);

    } else{
       fetchDenominations = this.$currentTab === "cashDeliveries"
        ? this.OrderViewService.getFundingSourceDenominationUnpack(branchFundingSourceId)
        : this.OrderViewService.getFundingSourceDenomination(branchFundingSourceId, locationId);
    }
    

    return fetchDenominations
      .then((res) => {
        let filteredResults = res.results.sort((a, b) => (a.sortOrder - b.sortOrder) || (a.faceValue - b.faceValue));
        if (currencyId) {
          filteredResults = res.results.sort((a, b) => (a.sortOrder - b.sortOrder) || (a.faceValue - b.faceValue)).filter(denom => denom.currencyId === currencyId);
        }
        
        // this.denominationAllType = filteredResults;
        let denominationsToUse = filteredResults.filter((d) => !d.unfit);
        if (this.customerUser) {
          denominationsToUse = denominationsToUse.filter((d) => d.customerOrderable);
        }
        
        this.denominationAllType = denominationsToUse;

        this.denomModelType.forEach((d) => {
          let type, remainingDenomModelKey;
          switch (d) {
            case "single":
              type = 'denominations';
              remainingDenomModelKey = 'remainingDenominations';
              break;
            case "multi":
              type = 'multiDenominations';
              remainingDenomModelKey = 'remainingMultiDenominations';
              break;
            case "atm":
              type = 'atmDenominations';
              remainingDenomModelKey = 'remainingAtmDenominations';
              break;
            default:
              'denominations';
          }
          // this.newCash[remainingDenomModelKey] = filteredResults.sort((a, b) => a.sortOrder - b.sortOrder);
          // if (filteredResults && filteredResults.length > 0) {
          this.newCash[remainingDenomModelKey] = denominationsToUse.sort((a, b) => (a.sortOrder - b.sortOrder) || (a.faceValue - b.faceValue));
          if (denominationsToUse && denominationsToUse.length > 0) {
            // for (var i = 0; this.newCash[type].length < length; i++) {
            //     console.log(this.newCash[remainingDenomModelKey][i].coinFlag, this.newCash[remainingDenomModelKey][i].id)
            //       this.newCash[type].push({
            //           isEnabled: i === 0,
            //           icon: this.newCash[remainingDenomModelKey].length > 0 ? this.newCash[remainingDenomModelKey][0].id : null,
            //           faceValue: this.newCash[remainingDenomModelKey].length > 0 ? this.newCash[remainingDenomModelKey][0].faceValue : 0,
            //           amount: null,
            //           template: d == 'single' ? 'order-view-denomination-selection.html' : 'order-view-multi-denomination-selection.html',
            //           dollarFlag: true,
            //           duplicate: false,
            //           multiDenomPackable: i == 0 ? true : this.newCash[remainingDenomModelKey][0].multiDenomPackable,
            //           strapCount: i === 0 ? 100 : (this.newCash[remainingDenomModelKey].length > 0 && this.newCash[remainingDenomModelKey][0].strapCount) || 0,
            //           coinFlag: this.newCash[remainingDenomModelKey][i].coinFlag
            //       });
            //       this.removeAlreadyUsedDenom(type, remainingDenomModelKey);
            //     }
            if (d == 'single') {
              // let allSingleDenoms = filteredResults.filter(d => !d.multiDenomPackable).map((denom, index) => ({
              let allSingleDenoms = denominationsToUse.filter(d => !d.multiDenomPackable).map((denom, index) => ({
                isEnabled: index == 0,
                icon: denom.id,
                faceValue: denom.faceValue,
                amount: null,
                template: "order-view-denomination-selection.html",
                dollarFlag: true,
                duplicate: true,
                multiDenomPackable: false,
                strapCount: denom.strapCount || 0,
                coinFlag: denom.coinFlag,
                sortOrder: denom.sortOrder,
                shiptypeId: denom.shiptypeId
              }));
              this.newCash.denominations.push(...allSingleDenoms)
              this.removeAlreadyUsedDenom('denominations', 'remainingDenominations');
              this.checkSingleDenomCoinShiptype();
            }
            else if (d == 'multi') {
              // let allMultiDenoms = filteredResults.filter(d => d.multiDenomPackable).map((denom, index) => ({
              let allMultiDenoms = denominationsToUse.filter(d => d.multiDenomPackable).map((denom, index) => ({
                isEnabled: index == 0,
                icon: denom.id,
                faceValue: denom.faceValue,
                amount: null,
                template: 'order-view-multi-denomination-selection.html',
                dollarFlag: true,
                duplicate: true,
                multiDenomPackable: true,
                strapCount: denom.strapCount || 0,
                coinFlag: denom.coinFlag,
                sortOrder: denom.sortOrder,
                shiptypeId: denom.shiptypeId
              })); 
              this.newCash.multiDenominations.push(...allMultiDenoms)
              this.removeAlreadyUsedDenom('multiDenominations', 'remainingMultiDenominations');
            }
            else if (d === 'atm') {
                  let allAtmDenoms = denominationsToUse.map((denom, index) => ({
                  isEnabled: index == 0,
                  id: denom.id,
                  icon: denom.id,
                  faceValue: denom.faceValue,
                  amount: null,
                  template: 'order-view-atm-denomination-selection.html',
                  dollarFlag: true,
                  duplicate: true,
                  multiDenomPackable: denom.multiDenomPackable,
                  strapCount: denom.strapCount || 0,
                  coinFlag: denom.coinFlag,
                  sortOrder: denom.sortOrder,
                  shiptypeId: denom.shiptypeId
                })); 
              // For ATM orders, allow as many denominations as are available (no hard cap)
              this.newCash.atmDenominations.push(...allAtmDenoms)
              this.removeAlreadyUsedDenom('atmDenominations', 'remainingAtmDenominations');
            }
          }
        })
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        this.loadBfsDenomination = false;
        if (this.newCash.orderType === 'P' || this.newCash.orderType === 'T') this.validateBillCount();
      });
  }

  onFundingSourceSelected() {
    this.newCash.toLocation = null;
    this.filterDataSet.locationList = [];
    this.filterDataSet.totalLocation = 0;
    this.newCash.routeId = null;
    if (this.userDetails.customerUser) {
      this.applyCustomerFundingSourceLeadDate();
    }
    this.loadLocation('', 0);
  }

  getSelectedFundingSourceLeadConfig() {    
    const fundingSource = this.newCash && this.newCash.fundingSource && this.newCash.fundingSource.dataObj
      ? this.newCash.fundingSource.dataObj
      : null;
    if (fundingSource &&
      'customerOrderLeadTime' in fundingSource &&
      'orderLeadDays' in fundingSource &&
      'orderLeadCutoff' in fundingSource
    ) return fundingSource;
    const selectedFundingSourceId = this.newCash
      ? (this.newCash.fundingSourceId || (this.newCash.fundingSource && this.newCash.fundingSource.Value))
      : null;
    if (!selectedFundingSourceId || !Array.isArray(this.filterDataSet.branchFundingSource)) return null;
    const selectedFundingSource = this.filterDataSet.branchFundingSource.find(
      bfs => String(bfs.Value) === String(selectedFundingSourceId)
    );
    return selectedFundingSource ? selectedFundingSource.dataObj : null;
  }

  getSelectedBranchCalendar() {
    return _.find(this.filterDataSet.userBranches, branch => branch.branchId == this.branchId);
  }

  isBranchBusinessDay(date, branchRow) {
    if (!branchRow) return true;
    const dayFlagByIsoWeekday = {
      1: 'businessDayMon', 2: 'businessDayTue', 3: 'businessDayWed', 4: 'businessDayThu',
      5: 'businessDayFri', 6: 'businessDaySat', 7: 'businessDaySun',
    };
    const flagName = dayFlagByIsoWeekday[date.isoWeekday()];
    return !!branchRow[flagName];
  }

  addBranchBusinessDays(startDate, days, branchRow) {
    let date = moment(startDate);
    if (!branchRow) return date.add(days, 'days');
    let counted = 0;
    while (counted < days) {
      date = date.add(1, 'day');
      if (this.isBranchBusinessDay(date, branchRow)) counted += 1;
    }
    return date;
  }

  isNonBusinessDay(date, mode) {
    if (mode !== 'day' || !this.shouldApplyCustomerFundingSourceLeadDate()) return false;
    return !this.isBranchBusinessDay(moment(date), this.getSelectedBranchCalendar());
  }

  getCustomerLeadMinDate() {
    const currentVaultDate = moment(this.filterDataSet.currentVaultDate);
    const fundingSource = this.getSelectedFundingSourceLeadConfig();
    if (!currentVaultDate.isValid() || !fundingSource || !fundingSource.customerOrderLeadTime) return null;

    const leadDays = Number(fundingSource.orderLeadDays);
    const cutoff = fundingSource.orderLeadCutoff;
    if (Number.isNaN(leadDays) || leadDays < 0 || !cutoff) return null;

    const parsedCutoff = moment(cutoff, ["HH:mm:ss", "HH:mm", "hh:mm A"], true);
    if (!parsedCutoff.isValid()) return null;

    const now = moment();
    const cutoffToday = moment().startOf("day")
      .hour(parsedCutoff.hour())
      .minute(parsedCutoff.minute())
      .second(parsedCutoff.second())
      .millisecond(0);
    const dayOffset = leadDays + (now.isAfter(cutoffToday) ? 1 : 0);
    const branchRow = this.getSelectedBranchCalendar();
    const minDate = this.addBranchBusinessDays(currentVaultDate.startOf("day"), dayOffset, branchRow);

    return minDate;
  }

  shouldApplyCustomerFundingSourceLeadDate() {
    const fundingSource = this.getSelectedFundingSourceLeadConfig();
    return !!(this.userDetails.customerUser
      && fundingSource
      && fundingSource.customerOrderLeadTime);
  }

  setMaxDate(minDate) {
    this.maxDate = this.maxDate || {};
    if (minDate) {
      this.maxDate.minDate = minDate;
    } else {
      delete this.maxDate.minDate;
    }
  }

  applyCustomerFundingSourceLeadDate() {
    const minDate = this.getCustomerLeadMinDate();
    this.setMaxDate(minDate);
    if (!minDate) return;
    this.newCash.vaultDate = moment(minDate);
    this.onVaultDateChange();
  }


  createPackableOrder() {
    this.newOrder = this.newCash;
    let totalAmount = 0,
    denominations = [];
    
    const branchId = this.getSelectedBranches().toString();
    this.newOrder.isCreating = true;
    this.newCash.isCreatingAtmOrders = true;

    this.newOrder.denominations.forEach(d => {
        if (d.isEnabled && d.amount >= 0) {
            const billCount = this.shouldUseAmountInput(d) ? this.getBillCountFromAmount(d.amount, d.faceValue) : d.billCount;
            denominations.push({
                denominationId: d.icon,
                amount: d.amount,
                multiDenomPackable: d.multiDenomPackable,
                coinFlag: d.coinFlag,
                shiptypeId: d.shiptypeId,
                qty: billCount
            });
            totalAmount += d.amount;
        }
    });

    this.newOrder.multiDenominations.forEach(d => {
      if (d.isEnabled && d.amount >= 0) {
          const billCount = this.shouldUseAmountInput(d) ? this.getBillCountFromAmount(d.amount, d.faceValue) : d.billCount;
          denominations.push({
              denominationId: d.icon,
              amount: d.amount,
              multiDenomPackable: d.multiDenomPackable,
              coinFlag: d.coinFlag,
              shiptypeId: d.shiptypeId,
              qty: billCount
          });
          totalAmount += d.amount;
      }
  });

    const obj = {
      fundingSourceId: this.newOrder.fundingSource.Value,
      locationId: this.newOrder.toLocation ? this.newOrder.toLocation.Value : null,
      orderNo: this.newOrder.orderNo,
      branchId,
      fromLocationId: this.newCash.fundingSource.dataObj["locationId"],
      routeId: this.newOrder.routeId.Value ? this.newOrder.routeId.Value : null,
      createdByUserId: this.userDetails.id,
      totalAmount: totalAmount,
      deliveryDate: moment(this.newOrder.vaultDate).format("YYYY-MM-DD"),
      comment: this.newOrder.comment ? this.newOrder.comment : null,
      denominations: denominations,
      account: this.newOrder.account,
      sourceName: this.newOrder.fundingSource.dataObj["sourceName"],
      currencyId: this.newOrder.fundingSource.dataObj["currencyId"]
    };

    this.OrderViewService.createPackableOrder(obj)
        .then(() => {
            this._calendar.isSidePanelOpen = false;
            this.getAtmOrders();
        })
        .catch(err => {
            if (err && err.data && err.data.errors && err.data.errors.length) {
                if (err.data.errors[0].path === "SHIPMENT.shipment_tracking_id_unique") {
                    this.Modal.errorModal("error.shipment_tracking_id_unique");
                }
            } else if (err && err.data && err.data.message) {
                this.Modal.errorModal(err.data.message);
            }
        })
        .finally(() => {
            this.newOrder.isCreating = false;
            this.newCash.isCreatingAtmOrders = false;
        });
  }

  removeUsedDenoms() {
    this.denomModelType.forEach((d) => {
      let type, remainingDenomModelKey;
      switch (d) {
        case "single":
          type = 'denominations';
          remainingDenomModelKey = 'remainingDenominations';
          break;
        case "multi":
          type = 'multiDenominations';
          remainingDenomModelKey = 'remainingMultiDenominations';
          break;
        case "atm":
          type = 'atmDenominations';
          remainingDenomModelKey = 'remainingAtmDenominations';
          break;
        default:
          'denominations';
      }
      this.removeAlreadyUsedDenom(type, remainingDenomModelKey);
    })
  }
  
  resetRouteId(key) {
    if (!this.model[key]) {
      this.newCash.routeId = null;
    }
  }

  editScheduledOrder(obj) {
    this.Modal.editScheduledOrders(obj, ({ modal, $scope, combinedRoutes, deletedRecurringStops }) => {
      this.OrderViewService.updateRecurrinRoute(combinedRoutes, deletedRecurringStops, obj.toLocationId, obj.branchId)
        .then(() => {
          setTimeout(() => {
            this.getAtmOrders();
          }, 100);
        })
        .catch((err) => {
          if (err && err.data && err.data.message) {
            this.Modal.errorModal(err.data.message);
          }
        })
        .finally(() => {
          $scope.model.isUpdating = false;
          modal.close();
        })
    }, ({ modal, err }) => {
      if (err && err.data && err.data.message) {
        modal.close();
        this.Modal.errorModal(err.data.message);
      } else {
        modal.close();
      }
    })
  }

  normalizeDate(dateStr) {
    const suffix = "T00:00:00.000Z";
    if (!dateStr.endsWith(suffix)) {
      return dateStr + suffix;
    }
    return dateStr;
  }

  onVaultDateChange() {
    // Reset route when date changes
    this.newCash.routeId = null;
    
    // Refresh routes for the new date
    if (this.newCash.toLocation) {
      this.getLocationNextRoute();
    }
    
    if (this.newCash.vaultDate && this.newCash.recurringStartDate) {
      if (moment(this.newCash.vaultDate).isAfter(this.newCash.recurringStartDate)) {
        this.newCash.recurringStartDate = moment(this.newCash.vaultDate);
      }
    }
  
    if (this.newCash.vaultDate) {
      this.minRecurrStartDate = {
        minDate: moment(this.newCash.vaultDate),
        maxDate: moment(this.newCash.recurringStartDate || this.newCash.vaultDate).add(1, "years"),
      };
    }
  }

  redirectToOrderPack = (order) => {
    const data = {
      orderNo: order.orderNo,
      routeId: order.routeId,
      vaultDate: moment(this.model.selectedBranch.currentVaultDate).format('YYYY-MM-DD'),
      locationId: order.toLocationId,
      fundingSourceId: order.fundingSourceId,
      isRedirected: true,
    }
    this.DataCounter.setData(data)
    this.$location.url('/app/order-packing')
  }

  convertScheduledOrderToPackableOrderModal(order) {
    this.Modal.confirm({
      header: this.$translate.instant("common.confirm_title"),
      message: this.$translate.instant("Are you sure you want to convert this scheduled order to Packable Order?"),
      callback: ({ modal }) => {
        modal.close();
        this.convertScheduledOrderToPackableOrder(order, modal);
      },
      negative: ({ modal }) => {
        modal.close();
      },
      buttons: ["common.ok", "common.cancel"],
      type: "primary",
    });
  }

  convertScheduledOrderToPackableOrder(order, modal) {
    this.isCretePackableOrder = true;
    const branchId = this.getSelectedBranches().toString();
    this.OrderViewService.convertScheduledOrderToPackableOrder(order.fundingSourceId, order.toLocationId, order.serviceDate, this.userDetails.id, branchId)
      .then(() => {
        setTimeout(() => {
          this.getAtmOrders();
        }, 100);
      })
      .catch((err) => {
        if (err && err.data && err.data.message) {
          this.Modal.errorModal(err.data.message);
        }
      })
      .finally(() => {
        if (modal) modal.close();
        this.isCretePackableOrder = false;
      })
  }

  convertNext7VaultDateScheduledOrderToPackableOrderModal(order) {
    this.Modal.confirm({
      header: this.$translate.instant("common.confirm_title"),
      message: this.$translate.instant("Are you sure you want to convert next 7 vaultDate scheduled orders to Packable Order?"),
      callback: ({ modal }) => {
        modal.close();
        this.convertNext7VaultDateScheduledOrderToPackableOrder(order, modal);
      },
      negative: ({ modal }) => {
        modal.close();
      },
      buttons: ["common.ok", "common.cancel"],
      type: "primary",
    });
  }

  convertNext7VaultDateScheduledOrderToPackableOrder(order, modal) {
    this.isCreteAllPackableOrder = true;
    const branchId = this.getSelectedBranches().toString();
    this.OrderViewService.convertScheduledOrderToPackableOrder(null, null, null, this.userDetails.id, branchId)
      .then(() => {
        setTimeout(() => {
          this.getAtmOrders();
        }, 100);
      })
      .catch((err) => {
        if (err && err.data && err.data.message) {
          this.Modal.errorModal(err.data.message);
        }
      })
      .finally(() => {
        if (modal) modal.close();
        this.isCreteAllPackableOrder = false;
      })
  }
}

export default MasterCashScheduleController;



// WEBPACK FOOTER //
// ./client/app/components/master_cash_schedule/master_cash_schedule.controller.js